/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Phrism SMCR API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  ActiveCertificationsOverviewDto,
  AnnualCertificationInitiateRequest,
  AnnualCompletedResponse,
  AnnualComplianceReviewResponse,
  AnnualComplianceReviewSummary,
  AnnualHrReviewResponse,
  AnnualHrReviewSummary,
  AnnualLineManagerReviewResponse,
  AnnualLineManagerReviewSummary,
  AnnualNotRequiredRequest,
  AnnualNotRequiredResponse,
  AnnualPopulationResponse,
  AnnualReviewOverviewDto,
  AnnualSelfDeclarationResponse,
  AnnualSignOffResponse,
  AnnualSignOffSummary,
  AwaitingCertificationSummary,
  BulkInviteRequest,
  BulkInviteResponse,
  CertificationCycleResponse,
  CertificationEnvelopeResponse,
  CheckPersonEmailAvailabilityParams,
  CompleteAnnualComplianceReviewRequest,
  CompleteCertificationCycleRequest,
  CompleteCertificationRequest,
  CompleteComplianceFinalSignOffRequest,
  CompleteComplianceReviewRequest,
  CompleteHrReviewRequest,
  CompleteLineManagerReviewRequest,
  ComplianceFinalSignOffResponse,
  ComplianceFinalSignOffSummary,
  ComplianceRegulatoryReferenceResponse,
  ComplianceRegulatoryReferenceSummary,
  ComplianceReviewResponse,
  ComplianceReviewSummary,
  CreateAdminPersonRequest,
  CreateCertificationCycleRequest,
  CreateOrganisationRequest,
  CreateOrganisationalFunctionRequest,
  CreatePersonRequest,
  CreateRegulatoryFunctionRequest,
  CurrentUserDto,
  DocumentDownloadUrlResponse,
  EditPersonRequest,
  EmailAvailabilityResponse,
  EmailTemplateTestRequest,
  EmailTestRequest,
  FormSubmission,
  GetAnnualCompletedParams,
  GetAnnualNotRequiredParams,
  GetAnnualPopulationParams,
  GetOrganisationsParams,
  GetRegulatoryFunctionsParams,
  HrRegulatoryReferenceResponse,
  HrRegulatoryReferenceSummary,
  HrReviewResponse,
  HrReviewSummary,
  InitiateLeaverRequest,
  InitiateRequest,
  InvitePersonRequest,
  LeaverPopulationRowPagedResponse,
  LineManagerCandidateResponse,
  LineManagerReviewResponse,
  LineManagerReviewSummary,
  ListLeaverPopulationParams,
  ListLineManagerCandidatesParams,
  ListMyAnnualSelfDeclarationsParams,
  ListMyComplianceRegulatoryReferencesParams,
  ListMyHrRegulatoryReferencesParams,
  ListMySelfDeclarationsParams,
  ListPeopleParams,
  ListRegulatoryFunctionsParams,
  ListRegulatoryReferenceCompletedParams,
  ListRegulatoryReferenceNotRequiredParams,
  MarkNotRequiredRequest,
  MarkRegulatoryReferenceNotRequiredRequest,
  MyAnnualSelfDeclarationSummary,
  MyDocumentSummary,
  MySelfDeclarationSummary,
  NewStarterCertificationOverviewDto,
  OnboardingResponse,
  OrganisationResponse,
  OrganisationalFunctionDto,
  PersonDetailResponse,
  PersonDocumentSummary,
  PersonResponse,
  PersonResponsePagedResponse,
  ProblemDetails,
  ReInvitePersonRequest,
  RegulatoryFunctionDto,
  RegulatoryFunctionResponse,
  RegulatoryReferenceCompletedRowPagedResponse,
  RegulatoryReferenceNotRequiredRowPagedResponse,
  RegulatoryReferenceOverviewDto,
  RegulatoryReferenceSubmission,
  SelfDeclarationForm,
  SelfDeclarationResponse,
  SubmitSelfDeclarationRequest,
  UpdateAdminPersonRequest,
  UpdateOrganisationRequest,
  UpdateRegulatoryFunctionRequest,
  ValidationProblemDetails
} from './models';

import { customInstance } from './mutator';
export const createAdminPerson = (
    orgId: MaybeRef<string>,
    createAdminPersonRequest: MaybeRef<CreateAdminPersonRequest>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
createAdminPersonRequest = unref(createAdminPersonRequest);

      return customInstance<PersonResponse>(
      {url: `/api/admin/organisations/${orgId}/people`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdminPersonRequest, signal
    },
      );
    }



export const getCreateAdminPersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminPerson>>, TError,{orgId: string;data: CreateAdminPersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminPerson>>, TError,{orgId: string;data: CreateAdminPersonRequest}, TContext> => {

const mutationKey = ['createAdminPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminPerson>>, {orgId: string;data: CreateAdminPersonRequest}> = (props) => {
          const {orgId,data} = props ?? {};

          return  createAdminPerson(orgId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminPersonMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminPerson>>>
    export type CreateAdminPersonMutationBody = CreateAdminPersonRequest
    export type CreateAdminPersonMutationError = ProblemDetails

    export const useCreateAdminPerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminPerson>>, TError,{orgId: string;data: CreateAdminPersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminPerson>>,
        TError,
        {orgId: string;data: CreateAdminPersonRequest},
        TContext
      > => {
      return useMutation(getCreateAdminPersonMutationOptions(options), queryClient);
    }

export const updateAdminPerson = (
    orgId: MaybeRef<string>,
    id: MaybeRef<string>,
    updateAdminPersonRequest: MaybeRef<UpdateAdminPersonRequest>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
id = unref(id);
updateAdminPersonRequest = unref(updateAdminPersonRequest);

      return customInstance<PersonResponse>(
      {url: `/api/admin/organisations/${orgId}/people/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAdminPersonRequest, signal
    },
      );
    }



export const getUpdateAdminPersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminPerson>>, TError,{orgId: string;id: string;data: UpdateAdminPersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminPerson>>, TError,{orgId: string;id: string;data: UpdateAdminPersonRequest}, TContext> => {

const mutationKey = ['updateAdminPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminPerson>>, {orgId: string;id: string;data: UpdateAdminPersonRequest}> = (props) => {
          const {orgId,id,data} = props ?? {};

          return  updateAdminPerson(orgId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminPersonMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminPerson>>>
    export type UpdateAdminPersonMutationBody = UpdateAdminPersonRequest
    export type UpdateAdminPersonMutationError = ProblemDetails

    export const useUpdateAdminPerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminPerson>>, TError,{orgId: string;id: string;data: UpdateAdminPersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAdminPerson>>,
        TError,
        {orgId: string;id: string;data: UpdateAdminPersonRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminPersonMutationOptions(options), queryClient);
    }

export const bulkInviteAdminPeople = (
    orgId: MaybeRef<string>,
    bulkInviteRequest: MaybeRef<BulkInviteRequest>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
bulkInviteRequest = unref(bulkInviteRequest);

      return customInstance<BulkInviteResponse>(
      {url: `/api/admin/organisations/${orgId}/people/bulk-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkInviteRequest, signal
    },
      );
    }



export const getBulkInviteAdminPeopleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, TError,{orgId: string;data: BulkInviteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, TError,{orgId: string;data: BulkInviteRequest}, TContext> => {

const mutationKey = ['bulkInviteAdminPeople'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, {orgId: string;data: BulkInviteRequest}> = (props) => {
          const {orgId,data} = props ?? {};

          return  bulkInviteAdminPeople(orgId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkInviteAdminPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof bulkInviteAdminPeople>>>
    export type BulkInviteAdminPeopleMutationBody = BulkInviteRequest
    export type BulkInviteAdminPeopleMutationError = ProblemDetails

    export const useBulkInviteAdminPeople = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, TError,{orgId: string;data: BulkInviteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof bulkInviteAdminPeople>>,
        TError,
        {orgId: string;data: BulkInviteRequest},
        TContext
      > => {
      return useMutation(getBulkInviteAdminPeopleMutationOptions(options), queryClient);
    }

export const revokeAdminPersonInvitation = (
    orgId: MaybeRef<string>,
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/organisations/${orgId}/people/${id}/revoke-invitation`, method: 'POST', signal
    },
      );
    }



export const getRevokeAdminPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext> => {

const mutationKey = ['revokeAdminPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, {orgId: string;id: string}> = (props) => {
          const {orgId,id} = props ?? {};

          return  revokeAdminPersonInvitation(orgId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAdminPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>>

    export type RevokeAdminPersonInvitationMutationError = ProblemDetails

    export const useRevokeAdminPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof revokeAdminPersonInvitation>>,
        TError,
        {orgId: string;id: string},
        TContext
      > => {
      return useMutation(getRevokeAdminPersonInvitationMutationOptions(options), queryClient);
    }

export const resendAdminPersonInvitation = (
    orgId: MaybeRef<string>,
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/organisations/${orgId}/people/${id}/resend-invitation`, method: 'POST', signal
    },
      );
    }



export const getResendAdminPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext> => {

const mutationKey = ['resendAdminPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, {orgId: string;id: string}> = (props) => {
          const {orgId,id} = props ?? {};

          return  resendAdminPersonInvitation(orgId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAdminPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendAdminPersonInvitation>>>

    export type ResendAdminPersonInvitationMutationError = ProblemDetails

    export const useResendAdminPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendAdminPersonInvitation>>,
        TError,
        {orgId: string;id: string},
        TContext
      > => {
      return useMutation(getResendAdminPersonInvitationMutationOptions(options), queryClient);
    }

export const getAnnualPopulation = (
    params?: MaybeRef<GetAnnualPopulationParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<AnnualPopulationResponse>(
      {url: `/api/annual-certifications/population`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetAnnualPopulationQueryKey = (params?: MaybeRef<GetAnnualPopulationParams>,) => {
    return [
    'api','annual-certifications','population', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnnualPopulationQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualPopulation>>, TError = ProblemDetails>(params?: MaybeRef<GetAnnualPopulationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualPopulation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualPopulationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualPopulation>>> = ({ signal }) => getAnnualPopulation(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualPopulation>>, TError, TData>
}

export type GetAnnualPopulationQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualPopulation>>>
export type GetAnnualPopulationQueryError = ProblemDetails



export function useGetAnnualPopulation<TData = Awaited<ReturnType<typeof getAnnualPopulation>>, TError = ProblemDetails>(
 params?: MaybeRef<GetAnnualPopulationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualPopulation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualPopulationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualCompleted = (
    params?: MaybeRef<GetAnnualCompletedParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<AnnualCompletedResponse>(
      {url: `/api/annual-certifications/completed`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetAnnualCompletedQueryKey = (params?: MaybeRef<GetAnnualCompletedParams>,) => {
    return [
    'api','annual-certifications','completed', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnnualCompletedQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualCompleted>>, TError = ProblemDetails>(params?: MaybeRef<GetAnnualCompletedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualCompleted>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualCompletedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualCompleted>>> = ({ signal }) => getAnnualCompleted(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualCompleted>>, TError, TData>
}

export type GetAnnualCompletedQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualCompleted>>>
export type GetAnnualCompletedQueryError = ProblemDetails



export function useGetAnnualCompleted<TData = Awaited<ReturnType<typeof getAnnualCompleted>>, TError = ProblemDetails>(
 params?: MaybeRef<GetAnnualCompletedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualCompleted>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualCompletedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const initiateAnnualCertifications = (
    annualCertificationInitiateRequest: MaybeRef<AnnualCertificationInitiateRequest>,
 signal?: AbortSignal
) => {
      annualCertificationInitiateRequest = unref(annualCertificationInitiateRequest);

      return customInstance<void>(
      {url: `/api/annual-certifications/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: annualCertificationInitiateRequest, signal
    },
      );
    }



export const getInitiateAnnualCertificationsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateAnnualCertifications>>, TError,{data: AnnualCertificationInitiateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiateAnnualCertifications>>, TError,{data: AnnualCertificationInitiateRequest}, TContext> => {

const mutationKey = ['initiateAnnualCertifications'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateAnnualCertifications>>, {data: AnnualCertificationInitiateRequest}> = (props) => {
          const {data} = props ?? {};

          return  initiateAnnualCertifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiateAnnualCertificationsMutationResult = NonNullable<Awaited<ReturnType<typeof initiateAnnualCertifications>>>
    export type InitiateAnnualCertificationsMutationBody = AnnualCertificationInitiateRequest
    export type InitiateAnnualCertificationsMutationError = ProblemDetails

    export const useInitiateAnnualCertifications = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateAnnualCertifications>>, TError,{data: AnnualCertificationInitiateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof initiateAnnualCertifications>>,
        TError,
        {data: AnnualCertificationInitiateRequest},
        TContext
      > => {
      return useMutation(getInitiateAnnualCertificationsMutationOptions(options), queryClient);
    }

export const markAnnualNotRequired = (
    annualNotRequiredRequest: MaybeRef<AnnualNotRequiredRequest>,
 signal?: AbortSignal
) => {
      annualNotRequiredRequest = unref(annualNotRequiredRequest);

      return customInstance<void>(
      {url: `/api/annual-certifications/mark-not-required`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: annualNotRequiredRequest, signal
    },
      );
    }



export const getMarkAnnualNotRequiredMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAnnualNotRequired>>, TError,{data: AnnualNotRequiredRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markAnnualNotRequired>>, TError,{data: AnnualNotRequiredRequest}, TContext> => {

const mutationKey = ['markAnnualNotRequired'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAnnualNotRequired>>, {data: AnnualNotRequiredRequest}> = (props) => {
          const {data} = props ?? {};

          return  markAnnualNotRequired(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAnnualNotRequiredMutationResult = NonNullable<Awaited<ReturnType<typeof markAnnualNotRequired>>>
    export type MarkAnnualNotRequiredMutationBody = AnnualNotRequiredRequest
    export type MarkAnnualNotRequiredMutationError = ProblemDetails

    export const useMarkAnnualNotRequired = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAnnualNotRequired>>, TError,{data: AnnualNotRequiredRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof markAnnualNotRequired>>,
        TError,
        {data: AnnualNotRequiredRequest},
        TContext
      > => {
      return useMutation(getMarkAnnualNotRequiredMutationOptions(options), queryClient);
    }

export const getAnnualNotRequired = (
    params?: MaybeRef<GetAnnualNotRequiredParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<AnnualNotRequiredResponse>(
      {url: `/api/annual-certifications/not-required`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetAnnualNotRequiredQueryKey = (params?: MaybeRef<GetAnnualNotRequiredParams>,) => {
    return [
    'api','annual-certifications','not-required', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnnualNotRequiredQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualNotRequired>>, TError = ProblemDetails>(params?: MaybeRef<GetAnnualNotRequiredParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualNotRequired>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualNotRequiredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualNotRequired>>> = ({ signal }) => getAnnualNotRequired(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualNotRequired>>, TError, TData>
}

export type GetAnnualNotRequiredQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualNotRequired>>>
export type GetAnnualNotRequiredQueryError = ProblemDetails



export function useGetAnnualNotRequired<TData = Awaited<ReturnType<typeof getAnnualNotRequired>>, TError = ProblemDetails>(
 params?: MaybeRef<GetAnnualNotRequiredParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualNotRequired>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualNotRequiredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualComplianceReview = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<AnnualComplianceReviewResponse>(
      {url: `/api/processes/${processId}/annual-compliance-review`, method: 'GET', signal
    },
      );
    }




export const getGetAnnualComplianceReviewQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'annual-compliance-review'
    ] as const;
    }


export const getGetAnnualComplianceReviewQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualComplianceReview>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualComplianceReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualComplianceReviewQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualComplianceReview>>> = ({ signal }) => getAnnualComplianceReview(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualComplianceReview>>, TError, TData>
}

export type GetAnnualComplianceReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualComplianceReview>>>
export type GetAnnualComplianceReviewQueryError = ProblemDetails



export function useGetAnnualComplianceReview<TData = Awaited<ReturnType<typeof getAnnualComplianceReview>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualComplianceReview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualComplianceReviewQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeAnnualComplianceReview = (
    processId: MaybeRef<string>,
    completeAnnualComplianceReviewRequest: MaybeRef<CompleteAnnualComplianceReviewRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
completeAnnualComplianceReviewRequest = unref(completeAnnualComplianceReviewRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/annual-compliance-review/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeAnnualComplianceReviewRequest, signal
    },
      );
    }



export const getCompleteAnnualComplianceReviewMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualComplianceReview>>, TError,{processId: string;data: CompleteAnnualComplianceReviewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeAnnualComplianceReview>>, TError,{processId: string;data: CompleteAnnualComplianceReviewRequest}, TContext> => {

const mutationKey = ['completeAnnualComplianceReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeAnnualComplianceReview>>, {processId: string;data: CompleteAnnualComplianceReviewRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeAnnualComplianceReview(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteAnnualComplianceReviewMutationResult = NonNullable<Awaited<ReturnType<typeof completeAnnualComplianceReview>>>
    export type CompleteAnnualComplianceReviewMutationBody = CompleteAnnualComplianceReviewRequest
    export type CompleteAnnualComplianceReviewMutationError = ProblemDetails | void

    export const useCompleteAnnualComplianceReview = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualComplianceReview>>, TError,{processId: string;data: CompleteAnnualComplianceReviewRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeAnnualComplianceReview>>,
        TError,
        {processId: string;data: CompleteAnnualComplianceReviewRequest},
        TContext
      > => {
      return useMutation(getCompleteAnnualComplianceReviewMutationOptions(options), queryClient);
    }

export const listMyAnnualComplianceReviews = (

 signal?: AbortSignal
) => {


      return customInstance<AnnualComplianceReviewSummary[]>(
      {url: `/api/me/annual-compliance-reviews-list`, method: 'GET', signal
    },
      );
    }




export const getListMyAnnualComplianceReviewsQueryKey = () => {
    return [
    'api','me','annual-compliance-reviews-list'
    ] as const;
    }


export const getListMyAnnualComplianceReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyAnnualComplianceReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>> = ({ signal }) => listMyAnnualComplianceReviews(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>, TError, TData>
}

export type ListMyAnnualComplianceReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>>
export type ListMyAnnualComplianceReviewsQueryError = ProblemDetails



export function useListMyAnnualComplianceReviews<TData = Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualComplianceReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAnnualComplianceReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualHrReview = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<AnnualHrReviewResponse>(
      {url: `/api/processes/${processId}/annual-hr-review`, method: 'GET', signal
    },
      );
    }




export const getGetAnnualHrReviewQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'annual-hr-review'
    ] as const;
    }


export const getGetAnnualHrReviewQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualHrReview>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualHrReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualHrReviewQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualHrReview>>> = ({ signal }) => getAnnualHrReview(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualHrReview>>, TError, TData>
}

export type GetAnnualHrReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualHrReview>>>
export type GetAnnualHrReviewQueryError = ProblemDetails



export function useGetAnnualHrReview<TData = Awaited<ReturnType<typeof getAnnualHrReview>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualHrReview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualHrReviewQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeAnnualHrReview = (
    processId: MaybeRef<string>,
    formSubmission: MaybeRef<FormSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
formSubmission = unref(formSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/annual-hr-review/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formSubmission, signal
    },
      );
    }



export const getCompleteAnnualHrReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualHrReview>>, TError,{processId: string;data: FormSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeAnnualHrReview>>, TError,{processId: string;data: FormSubmission}, TContext> => {

const mutationKey = ['completeAnnualHrReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeAnnualHrReview>>, {processId: string;data: FormSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeAnnualHrReview(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteAnnualHrReviewMutationResult = NonNullable<Awaited<ReturnType<typeof completeAnnualHrReview>>>
    export type CompleteAnnualHrReviewMutationBody = FormSubmission
    export type CompleteAnnualHrReviewMutationError = ProblemDetails

    export const useCompleteAnnualHrReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualHrReview>>, TError,{processId: string;data: FormSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeAnnualHrReview>>,
        TError,
        {processId: string;data: FormSubmission},
        TContext
      > => {
      return useMutation(getCompleteAnnualHrReviewMutationOptions(options), queryClient);
    }

export const listMyAnnualHrReviews = (

 signal?: AbortSignal
) => {


      return customInstance<AnnualHrReviewSummary[]>(
      {url: `/api/me/annual-hr-reviews-list`, method: 'GET', signal
    },
      );
    }




export const getListMyAnnualHrReviewsQueryKey = () => {
    return [
    'api','me','annual-hr-reviews-list'
    ] as const;
    }


export const getListMyAnnualHrReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAnnualHrReviews>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualHrReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyAnnualHrReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAnnualHrReviews>>> = ({ signal }) => listMyAnnualHrReviews(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualHrReviews>>, TError, TData>
}

export type ListMyAnnualHrReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAnnualHrReviews>>>
export type ListMyAnnualHrReviewsQueryError = ProblemDetails



export function useListMyAnnualHrReviews<TData = Awaited<ReturnType<typeof listMyAnnualHrReviews>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualHrReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAnnualHrReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualLineManagerReview = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<AnnualLineManagerReviewResponse>(
      {url: `/api/processes/${processId}/annual-line-manager-review`, method: 'GET', signal
    },
      );
    }




export const getGetAnnualLineManagerReviewQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'annual-line-manager-review'
    ] as const;
    }


export const getGetAnnualLineManagerReviewQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualLineManagerReview>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualLineManagerReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualLineManagerReviewQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualLineManagerReview>>> = ({ signal }) => getAnnualLineManagerReview(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualLineManagerReview>>, TError, TData>
}

export type GetAnnualLineManagerReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualLineManagerReview>>>
export type GetAnnualLineManagerReviewQueryError = ProblemDetails



export function useGetAnnualLineManagerReview<TData = Awaited<ReturnType<typeof getAnnualLineManagerReview>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualLineManagerReview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualLineManagerReviewQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeAnnualLineManagerReview = (
    processId: MaybeRef<string>,
    formSubmission: MaybeRef<FormSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
formSubmission = unref(formSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/annual-line-manager-review/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formSubmission, signal
    },
      );
    }



export const getCompleteAnnualLineManagerReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualLineManagerReview>>, TError,{processId: string;data: FormSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeAnnualLineManagerReview>>, TError,{processId: string;data: FormSubmission}, TContext> => {

const mutationKey = ['completeAnnualLineManagerReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeAnnualLineManagerReview>>, {processId: string;data: FormSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeAnnualLineManagerReview(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteAnnualLineManagerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof completeAnnualLineManagerReview>>>
    export type CompleteAnnualLineManagerReviewMutationBody = FormSubmission
    export type CompleteAnnualLineManagerReviewMutationError = ProblemDetails

    export const useCompleteAnnualLineManagerReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualLineManagerReview>>, TError,{processId: string;data: FormSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeAnnualLineManagerReview>>,
        TError,
        {processId: string;data: FormSubmission},
        TContext
      > => {
      return useMutation(getCompleteAnnualLineManagerReviewMutationOptions(options), queryClient);
    }

export const listMyAnnualLineManagerReviews = (

 signal?: AbortSignal
) => {


      return customInstance<AnnualLineManagerReviewSummary[]>(
      {url: `/api/me/annual-line-manager-reviews-list`, method: 'GET', signal
    },
      );
    }




export const getListMyAnnualLineManagerReviewsQueryKey = () => {
    return [
    'api','me','annual-line-manager-reviews-list'
    ] as const;
    }


export const getListMyAnnualLineManagerReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyAnnualLineManagerReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>> = ({ signal }) => listMyAnnualLineManagerReviews(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>, TError, TData>
}

export type ListMyAnnualLineManagerReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>>
export type ListMyAnnualLineManagerReviewsQueryError = ProblemDetails



export function useListMyAnnualLineManagerReviews<TData = Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualLineManagerReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAnnualLineManagerReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualSelfDeclaration = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<AnnualSelfDeclarationResponse>(
      {url: `/api/processes/${processId}/annual-self-declaration`, method: 'GET', signal
    },
      );
    }




export const getGetAnnualSelfDeclarationQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'annual-self-declaration'
    ] as const;
    }


export const getGetAnnualSelfDeclarationQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualSelfDeclaration>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualSelfDeclaration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualSelfDeclarationQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualSelfDeclaration>>> = ({ signal }) => getAnnualSelfDeclaration(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualSelfDeclaration>>, TError, TData>
}

export type GetAnnualSelfDeclarationQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualSelfDeclaration>>>
export type GetAnnualSelfDeclarationQueryError = ProblemDetails



export function useGetAnnualSelfDeclaration<TData = Awaited<ReturnType<typeof getAnnualSelfDeclaration>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualSelfDeclaration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualSelfDeclarationQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const saveAnnualSelfDeclarationDraft = (
    processId: MaybeRef<string>,
    formSubmission: MaybeRef<FormSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
formSubmission = unref(formSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/annual-self-declaration/draft`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: formSubmission, signal
    },
      );
    }



export const getSaveAnnualSelfDeclarationDraftMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAnnualSelfDeclarationDraft>>, TError,{processId: string;data: FormSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveAnnualSelfDeclarationDraft>>, TError,{processId: string;data: FormSubmission}, TContext> => {

const mutationKey = ['saveAnnualSelfDeclarationDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAnnualSelfDeclarationDraft>>, {processId: string;data: FormSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  saveAnnualSelfDeclarationDraft(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAnnualSelfDeclarationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveAnnualSelfDeclarationDraft>>>
    export type SaveAnnualSelfDeclarationDraftMutationBody = FormSubmission
    export type SaveAnnualSelfDeclarationDraftMutationError = ProblemDetails

    export const useSaveAnnualSelfDeclarationDraft = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAnnualSelfDeclarationDraft>>, TError,{processId: string;data: FormSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof saveAnnualSelfDeclarationDraft>>,
        TError,
        {processId: string;data: FormSubmission},
        TContext
      > => {
      return useMutation(getSaveAnnualSelfDeclarationDraftMutationOptions(options), queryClient);
    }

export const submitAnnualSelfDeclaration = (
    processId: MaybeRef<string>,
    formSubmission: MaybeRef<FormSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
formSubmission = unref(formSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/annual-self-declaration/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formSubmission, signal
    },
      );
    }



export const getSubmitAnnualSelfDeclarationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAnnualSelfDeclaration>>, TError,{processId: string;data: FormSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitAnnualSelfDeclaration>>, TError,{processId: string;data: FormSubmission}, TContext> => {

const mutationKey = ['submitAnnualSelfDeclaration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAnnualSelfDeclaration>>, {processId: string;data: FormSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  submitAnnualSelfDeclaration(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitAnnualSelfDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof submitAnnualSelfDeclaration>>>
    export type SubmitAnnualSelfDeclarationMutationBody = FormSubmission
    export type SubmitAnnualSelfDeclarationMutationError = ProblemDetails

    export const useSubmitAnnualSelfDeclaration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAnnualSelfDeclaration>>, TError,{processId: string;data: FormSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof submitAnnualSelfDeclaration>>,
        TError,
        {processId: string;data: FormSubmission},
        TContext
      > => {
      return useMutation(getSubmitAnnualSelfDeclarationMutationOptions(options), queryClient);
    }

export const listMyAnnualSelfDeclarations = (
    params?: MaybeRef<ListMyAnnualSelfDeclarationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<MyAnnualSelfDeclarationSummary[]>(
      {url: `/api/me/annual-self-declarations`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListMyAnnualSelfDeclarationsQueryKey = (params?: MaybeRef<ListMyAnnualSelfDeclarationsParams>,) => {
    return [
    'api','me','annual-self-declarations', ...(params ? [params] : [])
    ] as const;
    }


export const getListMyAnnualSelfDeclarationsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>, TError = ProblemDetails>(params?: MaybeRef<ListMyAnnualSelfDeclarationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyAnnualSelfDeclarationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>> = ({ signal }) => listMyAnnualSelfDeclarations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>, TError, TData>
}

export type ListMyAnnualSelfDeclarationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>>
export type ListMyAnnualSelfDeclarationsQueryError = ProblemDetails



export function useListMyAnnualSelfDeclarations<TData = Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>, TError = ProblemDetails>(
 params?: MaybeRef<ListMyAnnualSelfDeclarationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualSelfDeclarations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAnnualSelfDeclarationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualSignOff = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<AnnualSignOffResponse>(
      {url: `/api/processes/${processId}/annual-sign-off`, method: 'GET', signal
    },
      );
    }




export const getGetAnnualSignOffQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'annual-sign-off'
    ] as const;
    }


export const getGetAnnualSignOffQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualSignOff>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualSignOff>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualSignOffQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualSignOff>>> = ({ signal }) => getAnnualSignOff(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualSignOff>>, TError, TData>
}

export type GetAnnualSignOffQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualSignOff>>>
export type GetAnnualSignOffQueryError = ProblemDetails



export function useGetAnnualSignOff<TData = Awaited<ReturnType<typeof getAnnualSignOff>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualSignOff>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualSignOffQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeAnnualSignOff = (
    processId: MaybeRef<string>,
    formSubmission: MaybeRef<FormSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
formSubmission = unref(formSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/annual-sign-off/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formSubmission, signal
    },
      );
    }



export const getCompleteAnnualSignOffMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualSignOff>>, TError,{processId: string;data: FormSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeAnnualSignOff>>, TError,{processId: string;data: FormSubmission}, TContext> => {

const mutationKey = ['completeAnnualSignOff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeAnnualSignOff>>, {processId: string;data: FormSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeAnnualSignOff(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteAnnualSignOffMutationResult = NonNullable<Awaited<ReturnType<typeof completeAnnualSignOff>>>
    export type CompleteAnnualSignOffMutationBody = FormSubmission
    export type CompleteAnnualSignOffMutationError = ProblemDetails | void

    export const useCompleteAnnualSignOff = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeAnnualSignOff>>, TError,{processId: string;data: FormSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeAnnualSignOff>>,
        TError,
        {processId: string;data: FormSubmission},
        TContext
      > => {
      return useMutation(getCompleteAnnualSignOffMutationOptions(options), queryClient);
    }

export const listMyAnnualSignOffs = (

 signal?: AbortSignal
) => {


      return customInstance<AnnualSignOffSummary[]>(
      {url: `/api/me/annual-sign-offs-list`, method: 'GET', signal
    },
      );
    }




export const getListMyAnnualSignOffsQueryKey = () => {
    return [
    'api','me','annual-sign-offs-list'
    ] as const;
    }


export const getListMyAnnualSignOffsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAnnualSignOffs>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualSignOffs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyAnnualSignOffsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAnnualSignOffs>>> = ({ signal }) => listMyAnnualSignOffs(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualSignOffs>>, TError, TData>
}

export type ListMyAnnualSignOffsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAnnualSignOffs>>>
export type ListMyAnnualSignOffsQueryError = ProblemDetails



export function useListMyAnnualSignOffs<TData = Awaited<ReturnType<typeof listMyAnnualSignOffs>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAnnualSignOffs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAnnualSignOffsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getCertificationEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<CertificationEnvelopeResponse>(
      {url: `/api/processes/${processId}/certification`, method: 'GET', signal
    },
      );
    }




export const getGetCertificationEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'certification'
    ] as const;
    }


export const getGetCertificationEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getCertificationEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificationEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCertificationEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertificationEnvelope>>> = ({ signal }) => getCertificationEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertificationEnvelope>>, TError, TData>
}

export type GetCertificationEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getCertificationEnvelope>>>
export type GetCertificationEnvelopeQueryError = ProblemDetails



export function useGetCertificationEnvelope<TData = Awaited<ReturnType<typeof getCertificationEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificationEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCertificationEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeCertification = (
    processId: MaybeRef<string>,
    completeCertificationRequest: MaybeRef<CompleteCertificationRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
completeCertificationRequest = unref(completeCertificationRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/certification/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeCertificationRequest, signal
    },
      );
    }



export const getCompleteCertificationMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCertification>>, TError,{processId: string;data: CompleteCertificationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeCertification>>, TError,{processId: string;data: CompleteCertificationRequest}, TContext> => {

const mutationKey = ['completeCertification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeCertification>>, {processId: string;data: CompleteCertificationRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeCertification(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteCertificationMutationResult = NonNullable<Awaited<ReturnType<typeof completeCertification>>>
    export type CompleteCertificationMutationBody = CompleteCertificationRequest
    export type CompleteCertificationMutationError = ProblemDetails | void

    export const useCompleteCertification = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCertification>>, TError,{processId: string;data: CompleteCertificationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeCertification>>,
        TError,
        {processId: string;data: CompleteCertificationRequest},
        TContext
      > => {
      return useMutation(getCompleteCertificationMutationOptions(options), queryClient);
    }

export const listMyAwaitingCertifications = (

 signal?: AbortSignal
) => {


      return customInstance<AwaitingCertificationSummary[]>(
      {url: `/api/me/awaiting-certifications-list`, method: 'GET', signal
    },
      );
    }




export const getListMyAwaitingCertificationsQueryKey = () => {
    return [
    'api','me','awaiting-certifications-list'
    ] as const;
    }


export const getListMyAwaitingCertificationsQueryOptions = <TData = Awaited<ReturnType<typeof listMyAwaitingCertifications>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAwaitingCertifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyAwaitingCertificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyAwaitingCertifications>>> = ({ signal }) => listMyAwaitingCertifications(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyAwaitingCertifications>>, TError, TData>
}

export type ListMyAwaitingCertificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyAwaitingCertifications>>>
export type ListMyAwaitingCertificationsQueryError = ProblemDetails



export function useListMyAwaitingCertifications<TData = Awaited<ReturnType<typeof listMyAwaitingCertifications>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyAwaitingCertifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyAwaitingCertificationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getCertificationCycles = (

 signal?: AbortSignal
) => {


      return customInstance<CertificationCycleResponse[]>(
      {url: `/api/CertificationCycles`, method: 'GET', signal
    },
      );
    }




export const getGetCertificationCyclesQueryKey = () => {
    return [
    'api','CertificationCycles'
    ] as const;
    }


export const getGetCertificationCyclesQueryOptions = <TData = Awaited<ReturnType<typeof getCertificationCycles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificationCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCertificationCyclesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertificationCycles>>> = ({ signal }) => getCertificationCycles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertificationCycles>>, TError, TData>
}

export type GetCertificationCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof getCertificationCycles>>>
export type GetCertificationCyclesQueryError = unknown



export function useGetCertificationCycles<TData = Awaited<ReturnType<typeof getCertificationCycles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCertificationCycles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCertificationCyclesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createCertificationCycle = (
    createCertificationCycleRequest: MaybeRef<CreateCertificationCycleRequest>,
 signal?: AbortSignal
) => {
      createCertificationCycleRequest = unref(createCertificationCycleRequest);

      return customInstance<CertificationCycleResponse>(
      {url: `/api/CertificationCycles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCertificationCycleRequest, signal
    },
      );
    }



export const getCreateCertificationCycleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificationCycle>>, TError,{data: CreateCertificationCycleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCertificationCycle>>, TError,{data: CreateCertificationCycleRequest}, TContext> => {

const mutationKey = ['createCertificationCycle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCertificationCycle>>, {data: CreateCertificationCycleRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCertificationCycle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCertificationCycleMutationResult = NonNullable<Awaited<ReturnType<typeof createCertificationCycle>>>
    export type CreateCertificationCycleMutationBody = CreateCertificationCycleRequest
    export type CreateCertificationCycleMutationError = ProblemDetails

    export const useCreateCertificationCycle = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertificationCycle>>, TError,{data: CreateCertificationCycleRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCertificationCycle>>,
        TError,
        {data: CreateCertificationCycleRequest},
        TContext
      > => {
      return useMutation(getCreateCertificationCycleMutationOptions(options), queryClient);
    }

export const activateCertificationCycle = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<CertificationCycleResponse>(
      {url: `/api/CertificationCycles/${id}/activate`, method: 'POST', signal
    },
      );
    }



export const getActivateCertificationCycleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateCertificationCycle>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateCertificationCycle>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateCertificationCycle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateCertificationCycle>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateCertificationCycle(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateCertificationCycleMutationResult = NonNullable<Awaited<ReturnType<typeof activateCertificationCycle>>>

    export type ActivateCertificationCycleMutationError = ProblemDetails

    export const useActivateCertificationCycle = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateCertificationCycle>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateCertificationCycle>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getActivateCertificationCycleMutationOptions(options), queryClient);
    }

export const completeCertificationCycle = (
    id: MaybeRef<string>,
    completeCertificationCycleRequest: MaybeRef<CompleteCertificationCycleRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
completeCertificationCycleRequest = unref(completeCertificationCycleRequest);

      return customInstance<CertificationCycleResponse>(
      {url: `/api/CertificationCycles/${id}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeCertificationCycleRequest, signal
    },
      );
    }



export const getCompleteCertificationCycleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCertificationCycle>>, TError,{id: string;data: CompleteCertificationCycleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeCertificationCycle>>, TError,{id: string;data: CompleteCertificationCycleRequest}, TContext> => {

const mutationKey = ['completeCertificationCycle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeCertificationCycle>>, {id: string;data: CompleteCertificationCycleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  completeCertificationCycle(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteCertificationCycleMutationResult = NonNullable<Awaited<ReturnType<typeof completeCertificationCycle>>>
    export type CompleteCertificationCycleMutationBody = CompleteCertificationCycleRequest
    export type CompleteCertificationCycleMutationError = ProblemDetails

    export const useCompleteCertificationCycle = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCertificationCycle>>, TError,{id: string;data: CompleteCertificationCycleRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeCertificationCycle>>,
        TError,
        {id: string;data: CompleteCertificationCycleRequest},
        TContext
      > => {
      return useMutation(getCompleteCertificationCycleMutationOptions(options), queryClient);
    }

export const clerkWebhook = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/webhooks/clerk`, method: 'POST', signal
    },
      );
    }



export const getClerkWebhookMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clerkWebhook>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clerkWebhook>>, TError,void, TContext> => {

const mutationKey = ['clerkWebhook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clerkWebhook>>, void> = () => {


          return  clerkWebhook()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClerkWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof clerkWebhook>>>

    export type ClerkWebhookMutationError = ProblemDetails

    export const useClerkWebhook = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clerkWebhook>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof clerkWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClerkWebhookMutationOptions(options), queryClient);
    }

export const getCompany = (

 signal?: AbortSignal
) => {


      return customInstance<OrganisationResponse>(
      {url: `/api/Company`, method: 'GET', signal
    },
      );
    }




export const getGetCompanyQueryKey = () => {
    return [
    'api','Company'
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = ProblemDetails



export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const updateCompany = (
    updateOrganisationRequest: MaybeRef<UpdateOrganisationRequest>,
 signal?: AbortSignal
) => {
      updateOrganisationRequest = unref(updateOrganisationRequest);

      return customInstance<OrganisationResponse>(
      {url: `/api/Company`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganisationRequest, signal
    },
      );
    }



export const getUpdateCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: UpdateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: UpdateOrganisationRequest}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {data: UpdateOrganisationRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateCompany(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = UpdateOrganisationRequest
    export type UpdateCompanyMutationError = ProblemDetails

    export const useUpdateCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: UpdateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {data: UpdateOrganisationRequest},
        TContext
      > => {
      return useMutation(getUpdateCompanyMutationOptions(options), queryClient);
    }

export const getComplianceFinalSignOffEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<ComplianceFinalSignOffResponse>(
      {url: `/api/processes/${processId}/compliance-final-sign-off`, method: 'GET', signal
    },
      );
    }




export const getGetComplianceFinalSignOffEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'compliance-final-sign-off'
    ] as const;
    }


export const getGetComplianceFinalSignOffEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetComplianceFinalSignOffEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>> = ({ signal }) => getComplianceFinalSignOffEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>, TError, TData>
}

export type GetComplianceFinalSignOffEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>>
export type GetComplianceFinalSignOffEnvelopeQueryError = ProblemDetails



export function useGetComplianceFinalSignOffEnvelope<TData = Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComplianceFinalSignOffEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetComplianceFinalSignOffEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeComplianceFinalSignOff = (
    processId: MaybeRef<string>,
    completeComplianceFinalSignOffRequest: MaybeRef<CompleteComplianceFinalSignOffRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
completeComplianceFinalSignOffRequest = unref(completeComplianceFinalSignOffRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/compliance-final-sign-off/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeComplianceFinalSignOffRequest, signal
    },
      );
    }



export const getCompleteComplianceFinalSignOffMutationOptions = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeComplianceFinalSignOff>>, TError,{processId: string;data: CompleteComplianceFinalSignOffRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeComplianceFinalSignOff>>, TError,{processId: string;data: CompleteComplianceFinalSignOffRequest}, TContext> => {

const mutationKey = ['completeComplianceFinalSignOff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeComplianceFinalSignOff>>, {processId: string;data: CompleteComplianceFinalSignOffRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeComplianceFinalSignOff(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteComplianceFinalSignOffMutationResult = NonNullable<Awaited<ReturnType<typeof completeComplianceFinalSignOff>>>
    export type CompleteComplianceFinalSignOffMutationBody = CompleteComplianceFinalSignOffRequest
    export type CompleteComplianceFinalSignOffMutationError = ProblemDetails | void

    export const useCompleteComplianceFinalSignOff = <TError = ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeComplianceFinalSignOff>>, TError,{processId: string;data: CompleteComplianceFinalSignOffRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeComplianceFinalSignOff>>,
        TError,
        {processId: string;data: CompleteComplianceFinalSignOffRequest},
        TContext
      > => {
      return useMutation(getCompleteComplianceFinalSignOffMutationOptions(options), queryClient);
    }

export const listMyComplianceFinalSignOffs = (

 signal?: AbortSignal
) => {


      return customInstance<ComplianceFinalSignOffSummary[]>(
      {url: `/api/me/compliance-final-sign-offs-list`, method: 'GET', signal
    },
      );
    }




export const getListMyComplianceFinalSignOffsQueryKey = () => {
    return [
    'api','me','compliance-final-sign-offs-list'
    ] as const;
    }


export const getListMyComplianceFinalSignOffsQueryOptions = <TData = Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyComplianceFinalSignOffsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>> = ({ signal }) => listMyComplianceFinalSignOffs(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>, TError, TData>
}

export type ListMyComplianceFinalSignOffsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>>
export type ListMyComplianceFinalSignOffsQueryError = ProblemDetails



export function useListMyComplianceFinalSignOffs<TData = Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceFinalSignOffs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyComplianceFinalSignOffsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getComplianceRegulatoryReferenceEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<ComplianceRegulatoryReferenceResponse>(
      {url: `/api/processes/${processId}/compliance-regulatory-reference`, method: 'GET', signal
    },
      );
    }




export const getGetComplianceRegulatoryReferenceEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'compliance-regulatory-reference'
    ] as const;
    }


export const getGetComplianceRegulatoryReferenceEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetComplianceRegulatoryReferenceEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>> = ({ signal }) => getComplianceRegulatoryReferenceEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>, TError, TData>
}

export type GetComplianceRegulatoryReferenceEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>>
export type GetComplianceRegulatoryReferenceEnvelopeQueryError = ProblemDetails



export function useGetComplianceRegulatoryReferenceEnvelope<TData = Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComplianceRegulatoryReferenceEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetComplianceRegulatoryReferenceEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const submitComplianceRegulatoryReference = (
    processId: MaybeRef<string>,
    regulatoryReferenceSubmission: MaybeRef<RegulatoryReferenceSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
regulatoryReferenceSubmission = unref(regulatoryReferenceSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/compliance-regulatory-reference/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: regulatoryReferenceSubmission, signal
    },
      );
    }



export const getSubmitComplianceRegulatoryReferenceMutationOptions = <TError = ValidationProblemDetails | ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitComplianceRegulatoryReference>>, TError,{processId: string;data: RegulatoryReferenceSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitComplianceRegulatoryReference>>, TError,{processId: string;data: RegulatoryReferenceSubmission}, TContext> => {

const mutationKey = ['submitComplianceRegulatoryReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitComplianceRegulatoryReference>>, {processId: string;data: RegulatoryReferenceSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  submitComplianceRegulatoryReference(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitComplianceRegulatoryReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof submitComplianceRegulatoryReference>>>
    export type SubmitComplianceRegulatoryReferenceMutationBody = RegulatoryReferenceSubmission
    export type SubmitComplianceRegulatoryReferenceMutationError = ValidationProblemDetails | ProblemDetails | void

    export const useSubmitComplianceRegulatoryReference = <TError = ValidationProblemDetails | ProblemDetails | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitComplianceRegulatoryReference>>, TError,{processId: string;data: RegulatoryReferenceSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof submitComplianceRegulatoryReference>>,
        TError,
        {processId: string;data: RegulatoryReferenceSubmission},
        TContext
      > => {
      return useMutation(getSubmitComplianceRegulatoryReferenceMutationOptions(options), queryClient);
    }

export const listMyComplianceRegulatoryReferences = (
    params?: MaybeRef<ListMyComplianceRegulatoryReferencesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<ComplianceRegulatoryReferenceSummary[]>(
      {url: `/api/me/compliance-regulatory-references-list`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListMyComplianceRegulatoryReferencesQueryKey = (params?: MaybeRef<ListMyComplianceRegulatoryReferencesParams>,) => {
    return [
    'api','me','compliance-regulatory-references-list', ...(params ? [params] : [])
    ] as const;
    }


export const getListMyComplianceRegulatoryReferencesQueryOptions = <TData = Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>, TError = ProblemDetails>(params?: MaybeRef<ListMyComplianceRegulatoryReferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyComplianceRegulatoryReferencesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>> = ({ signal }) => listMyComplianceRegulatoryReferences(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>, TError, TData>
}

export type ListMyComplianceRegulatoryReferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>>
export type ListMyComplianceRegulatoryReferencesQueryError = ProblemDetails



export function useListMyComplianceRegulatoryReferences<TData = Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>, TError = ProblemDetails>(
 params?: MaybeRef<ListMyComplianceRegulatoryReferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceRegulatoryReferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyComplianceRegulatoryReferencesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getComplianceReviewEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<ComplianceReviewResponse>(
      {url: `/api/processes/${processId}/compliance-review`, method: 'GET', signal
    },
      );
    }




export const getGetComplianceReviewEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'compliance-review'
    ] as const;
    }


export const getGetComplianceReviewEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getComplianceReviewEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComplianceReviewEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetComplianceReviewEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComplianceReviewEnvelope>>> = ({ signal }) => getComplianceReviewEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComplianceReviewEnvelope>>, TError, TData>
}

export type GetComplianceReviewEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getComplianceReviewEnvelope>>>
export type GetComplianceReviewEnvelopeQueryError = ProblemDetails



export function useGetComplianceReviewEnvelope<TData = Awaited<ReturnType<typeof getComplianceReviewEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getComplianceReviewEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetComplianceReviewEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeComplianceReview = (
    processId: MaybeRef<string>,
    completeComplianceReviewRequest: MaybeRef<CompleteComplianceReviewRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
completeComplianceReviewRequest = unref(completeComplianceReviewRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/compliance-review/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeComplianceReviewRequest, signal
    },
      );
    }



export const getCompleteComplianceReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeComplianceReview>>, TError,{processId: string;data: CompleteComplianceReviewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeComplianceReview>>, TError,{processId: string;data: CompleteComplianceReviewRequest}, TContext> => {

const mutationKey = ['completeComplianceReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeComplianceReview>>, {processId: string;data: CompleteComplianceReviewRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeComplianceReview(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteComplianceReviewMutationResult = NonNullable<Awaited<ReturnType<typeof completeComplianceReview>>>
    export type CompleteComplianceReviewMutationBody = CompleteComplianceReviewRequest
    export type CompleteComplianceReviewMutationError = ProblemDetails

    export const useCompleteComplianceReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeComplianceReview>>, TError,{processId: string;data: CompleteComplianceReviewRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeComplianceReview>>,
        TError,
        {processId: string;data: CompleteComplianceReviewRequest},
        TContext
      > => {
      return useMutation(getCompleteComplianceReviewMutationOptions(options), queryClient);
    }

export const listMyComplianceReviews = (

 signal?: AbortSignal
) => {


      return customInstance<ComplianceReviewSummary[]>(
      {url: `/api/me/compliance-reviews-list`, method: 'GET', signal
    },
      );
    }




export const getListMyComplianceReviewsQueryKey = () => {
    return [
    'api','me','compliance-reviews-list'
    ] as const;
    }


export const getListMyComplianceReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listMyComplianceReviews>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyComplianceReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyComplianceReviews>>> = ({ signal }) => listMyComplianceReviews(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceReviews>>, TError, TData>
}

export type ListMyComplianceReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyComplianceReviews>>>
export type ListMyComplianceReviewsQueryError = ProblemDetails



export function useListMyComplianceReviews<TData = Awaited<ReturnType<typeof listMyComplianceReviews>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyComplianceReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyComplianceReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getNewStarterCertificationOverview = (

 signal?: AbortSignal
) => {


      return customInstance<NewStarterCertificationOverviewDto>(
      {url: `/api/dashboard/new-starter-certification`, method: 'GET', signal
    },
      );
    }




export const getGetNewStarterCertificationOverviewQueryKey = () => {
    return [
    'api','dashboard','new-starter-certification'
    ] as const;
    }


export const getGetNewStarterCertificationOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getNewStarterCertificationOverview>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewStarterCertificationOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetNewStarterCertificationOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewStarterCertificationOverview>>> = ({ signal }) => getNewStarterCertificationOverview(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewStarterCertificationOverview>>, TError, TData>
}

export type GetNewStarterCertificationOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getNewStarterCertificationOverview>>>
export type GetNewStarterCertificationOverviewQueryError = unknown



export function useGetNewStarterCertificationOverview<TData = Awaited<ReturnType<typeof getNewStarterCertificationOverview>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewStarterCertificationOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewStarterCertificationOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getActiveCertificationsOverview = (

 signal?: AbortSignal
) => {


      return customInstance<ActiveCertificationsOverviewDto>(
      {url: `/api/dashboard/active-certifications`, method: 'GET', signal
    },
      );
    }




export const getGetActiveCertificationsOverviewQueryKey = () => {
    return [
    'api','dashboard','active-certifications'
    ] as const;
    }


export const getGetActiveCertificationsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getActiveCertificationsOverview>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCertificationsOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetActiveCertificationsOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveCertificationsOverview>>> = ({ signal }) => getActiveCertificationsOverview(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveCertificationsOverview>>, TError, TData>
}

export type GetActiveCertificationsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveCertificationsOverview>>>
export type GetActiveCertificationsOverviewQueryError = ProblemDetails



export function useGetActiveCertificationsOverview<TData = Awaited<ReturnType<typeof getActiveCertificationsOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCertificationsOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveCertificationsOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getRegulatoryReferenceOverview = (

 signal?: AbortSignal
) => {


      return customInstance<RegulatoryReferenceOverviewDto>(
      {url: `/api/dashboard/regulatory-reference`, method: 'GET', signal
    },
      );
    }




export const getGetRegulatoryReferenceOverviewQueryKey = () => {
    return [
    'api','dashboard','regulatory-reference'
    ] as const;
    }


export const getGetRegulatoryReferenceOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetRegulatoryReferenceOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>> = ({ signal }) => getRegulatoryReferenceOverview(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>, TError, TData>
}

export type GetRegulatoryReferenceOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>>
export type GetRegulatoryReferenceOverviewQueryError = ProblemDetails



export function useGetRegulatoryReferenceOverview<TData = Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReferenceOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulatoryReferenceOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getAnnualReviewOverview = (

 signal?: AbortSignal
) => {


      return customInstance<AnnualReviewOverviewDto>(
      {url: `/api/dashboard/annual-review`, method: 'GET', signal
    },
      );
    }




export const getGetAnnualReviewOverviewQueryKey = () => {
    return [
    'api','dashboard','annual-review'
    ] as const;
    }


export const getGetAnnualReviewOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAnnualReviewOverview>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualReviewOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAnnualReviewOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnualReviewOverview>>> = ({ signal }) => getAnnualReviewOverview(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnualReviewOverview>>, TError, TData>
}

export type GetAnnualReviewOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnualReviewOverview>>>
export type GetAnnualReviewOverviewQueryError = ProblemDetails



export function useGetAnnualReviewOverview<TData = Awaited<ReturnType<typeof getAnnualReviewOverview>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnualReviewOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnualReviewOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listMyDocuments = (

 signal?: AbortSignal
) => {


      return customInstance<MyDocumentSummary[]>(
      {url: `/api/me/documents`, method: 'GET', signal
    },
      );
    }




export const getListMyDocumentsQueryKey = () => {
    return [
    'api','me','documents'
    ] as const;
    }


export const getListMyDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listMyDocuments>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyDocuments>>> = ({ signal }) => listMyDocuments(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyDocuments>>, TError, TData>
}

export type ListMyDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyDocuments>>>
export type ListMyDocumentsQueryError = ProblemDetails



export function useListMyDocuments<TData = Awaited<ReturnType<typeof listMyDocuments>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createMyDocumentDownloadUrl = (
    documentId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      documentId = unref(documentId);

      return customInstance<DocumentDownloadUrlResponse>(
      {url: `/api/me/documents/${documentId}/download-url`, method: 'POST', signal
    },
      );
    }



export const getCreateMyDocumentDownloadUrlMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyDocumentDownloadUrl>>, TError,{documentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMyDocumentDownloadUrl>>, TError,{documentId: string}, TContext> => {

const mutationKey = ['createMyDocumentDownloadUrl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyDocumentDownloadUrl>>, {documentId: string}> = (props) => {
          const {documentId} = props ?? {};

          return  createMyDocumentDownloadUrl(documentId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyDocumentDownloadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof createMyDocumentDownloadUrl>>>

    export type CreateMyDocumentDownloadUrlMutationError = ProblemDetails

    export const useCreateMyDocumentDownloadUrl = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyDocumentDownloadUrl>>, TError,{documentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMyDocumentDownloadUrl>>,
        TError,
        {documentId: string},
        TContext
      > => {
      return useMutation(getCreateMyDocumentDownloadUrlMutationOptions(options), queryClient);
    }

export const getHrRegulatoryReferenceEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<HrRegulatoryReferenceResponse>(
      {url: `/api/processes/${processId}/hr-regulatory-reference`, method: 'GET', signal
    },
      );
    }




export const getGetHrRegulatoryReferenceEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'hr-regulatory-reference'
    ] as const;
    }


export const getGetHrRegulatoryReferenceEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetHrRegulatoryReferenceEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>> = ({ signal }) => getHrRegulatoryReferenceEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>, TError, TData>
}

export type GetHrRegulatoryReferenceEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>>
export type GetHrRegulatoryReferenceEnvelopeQueryError = ProblemDetails



export function useGetHrRegulatoryReferenceEnvelope<TData = Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrRegulatoryReferenceEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHrRegulatoryReferenceEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const submitHrRegulatoryReference = (
    processId: MaybeRef<string>,
    regulatoryReferenceSubmission: MaybeRef<RegulatoryReferenceSubmission>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
regulatoryReferenceSubmission = unref(regulatoryReferenceSubmission);

      return customInstance<void>(
      {url: `/api/processes/${processId}/hr-regulatory-reference/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: regulatoryReferenceSubmission, signal
    },
      );
    }



export const getSubmitHrRegulatoryReferenceMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHrRegulatoryReference>>, TError,{processId: string;data: RegulatoryReferenceSubmission}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitHrRegulatoryReference>>, TError,{processId: string;data: RegulatoryReferenceSubmission}, TContext> => {

const mutationKey = ['submitHrRegulatoryReference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitHrRegulatoryReference>>, {processId: string;data: RegulatoryReferenceSubmission}> = (props) => {
          const {processId,data} = props ?? {};

          return  submitHrRegulatoryReference(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitHrRegulatoryReferenceMutationResult = NonNullable<Awaited<ReturnType<typeof submitHrRegulatoryReference>>>
    export type SubmitHrRegulatoryReferenceMutationBody = RegulatoryReferenceSubmission
    export type SubmitHrRegulatoryReferenceMutationError = ValidationProblemDetails | ProblemDetails

    export const useSubmitHrRegulatoryReference = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHrRegulatoryReference>>, TError,{processId: string;data: RegulatoryReferenceSubmission}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof submitHrRegulatoryReference>>,
        TError,
        {processId: string;data: RegulatoryReferenceSubmission},
        TContext
      > => {
      return useMutation(getSubmitHrRegulatoryReferenceMutationOptions(options), queryClient);
    }

export const listMyHrRegulatoryReferences = (
    params?: MaybeRef<ListMyHrRegulatoryReferencesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<HrRegulatoryReferenceSummary[]>(
      {url: `/api/me/hr-regulatory-references-list`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListMyHrRegulatoryReferencesQueryKey = (params?: MaybeRef<ListMyHrRegulatoryReferencesParams>,) => {
    return [
    'api','me','hr-regulatory-references-list', ...(params ? [params] : [])
    ] as const;
    }


export const getListMyHrRegulatoryReferencesQueryOptions = <TData = Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>, TError = ProblemDetails>(params?: MaybeRef<ListMyHrRegulatoryReferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyHrRegulatoryReferencesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>> = ({ signal }) => listMyHrRegulatoryReferences(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>, TError, TData>
}

export type ListMyHrRegulatoryReferencesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>>
export type ListMyHrRegulatoryReferencesQueryError = ProblemDetails



export function useListMyHrRegulatoryReferences<TData = Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>, TError = ProblemDetails>(
 params?: MaybeRef<ListMyHrRegulatoryReferencesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyHrRegulatoryReferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyHrRegulatoryReferencesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getHrReviewEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<HrReviewResponse>(
      {url: `/api/processes/${processId}/hr-review`, method: 'GET', signal
    },
      );
    }




export const getGetHrReviewEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'hr-review'
    ] as const;
    }


export const getGetHrReviewEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getHrReviewEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrReviewEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetHrReviewEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrReviewEnvelope>>> = ({ signal }) => getHrReviewEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrReviewEnvelope>>, TError, TData>
}

export type GetHrReviewEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getHrReviewEnvelope>>>
export type GetHrReviewEnvelopeQueryError = ProblemDetails



export function useGetHrReviewEnvelope<TData = Awaited<ReturnType<typeof getHrReviewEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrReviewEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHrReviewEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeHrReview = (
    processId: MaybeRef<string>,
    completeHrReviewRequest: MaybeRef<CompleteHrReviewRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
completeHrReviewRequest = unref(completeHrReviewRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/hr-review/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeHrReviewRequest, signal
    },
      );
    }



export const getCompleteHrReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeHrReview>>, TError,{processId: string;data: CompleteHrReviewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeHrReview>>, TError,{processId: string;data: CompleteHrReviewRequest}, TContext> => {

const mutationKey = ['completeHrReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeHrReview>>, {processId: string;data: CompleteHrReviewRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeHrReview(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteHrReviewMutationResult = NonNullable<Awaited<ReturnType<typeof completeHrReview>>>
    export type CompleteHrReviewMutationBody = CompleteHrReviewRequest
    export type CompleteHrReviewMutationError = ProblemDetails

    export const useCompleteHrReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeHrReview>>, TError,{processId: string;data: CompleteHrReviewRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeHrReview>>,
        TError,
        {processId: string;data: CompleteHrReviewRequest},
        TContext
      > => {
      return useMutation(getCompleteHrReviewMutationOptions(options), queryClient);
    }

export const listMyHrReviews = (

 signal?: AbortSignal
) => {


      return customInstance<HrReviewSummary[]>(
      {url: `/api/me/hr-reviews-list`, method: 'GET', signal
    },
      );
    }




export const getListMyHrReviewsQueryKey = () => {
    return [
    'api','me','hr-reviews-list'
    ] as const;
    }


export const getListMyHrReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listMyHrReviews>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyHrReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyHrReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyHrReviews>>> = ({ signal }) => listMyHrReviews(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyHrReviews>>, TError, TData>
}

export type ListMyHrReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyHrReviews>>>
export type ListMyHrReviewsQueryError = ProblemDetails



export function useListMyHrReviews<TData = Awaited<ReturnType<typeof listMyHrReviews>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyHrReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyHrReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listLeaverPopulation = (
    params?: MaybeRef<ListLeaverPopulationParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<LeaverPopulationRowPagedResponse>(
      {url: `/api/Leavers/population`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListLeaverPopulationQueryKey = (params?: MaybeRef<ListLeaverPopulationParams>,) => {
    return [
    'api','Leavers','population', ...(params ? [params] : [])
    ] as const;
    }


export const getListLeaverPopulationQueryOptions = <TData = Awaited<ReturnType<typeof listLeaverPopulation>>, TError = ProblemDetails>(params?: MaybeRef<ListLeaverPopulationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeaverPopulation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListLeaverPopulationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeaverPopulation>>> = ({ signal }) => listLeaverPopulation(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeaverPopulation>>, TError, TData>
}

export type ListLeaverPopulationQueryResult = NonNullable<Awaited<ReturnType<typeof listLeaverPopulation>>>
export type ListLeaverPopulationQueryError = ProblemDetails



export function useListLeaverPopulation<TData = Awaited<ReturnType<typeof listLeaverPopulation>>, TError = ProblemDetails>(
 params?: MaybeRef<ListLeaverPopulationParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeaverPopulation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLeaverPopulationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const initiateLeaverPeople = (
    initiateLeaverRequest: MaybeRef<InitiateLeaverRequest>,
 signal?: AbortSignal
) => {
      initiateLeaverRequest = unref(initiateLeaverRequest);

      return customInstance<void>(
      {url: `/api/Leavers/initiate-leaver`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateLeaverRequest, signal
    },
      );
    }



export const getInitiateLeaverPeopleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateLeaverPeople>>, TError,{data: InitiateLeaverRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiateLeaverPeople>>, TError,{data: InitiateLeaverRequest}, TContext> => {

const mutationKey = ['initiateLeaverPeople'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateLeaverPeople>>, {data: InitiateLeaverRequest}> = (props) => {
          const {data} = props ?? {};

          return  initiateLeaverPeople(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiateLeaverPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof initiateLeaverPeople>>>
    export type InitiateLeaverPeopleMutationBody = InitiateLeaverRequest
    export type InitiateLeaverPeopleMutationError = ProblemDetails

    export const useInitiateLeaverPeople = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateLeaverPeople>>, TError,{data: InitiateLeaverRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof initiateLeaverPeople>>,
        TError,
        {data: InitiateLeaverRequest},
        TContext
      > => {
      return useMutation(getInitiateLeaverPeopleMutationOptions(options), queryClient);
    }

export const markRegulatoryReferenceNotRequired = (
    markRegulatoryReferenceNotRequiredRequest: MaybeRef<MarkRegulatoryReferenceNotRequiredRequest>,
 signal?: AbortSignal
) => {
      markRegulatoryReferenceNotRequiredRequest = unref(markRegulatoryReferenceNotRequiredRequest);

      return customInstance<void>(
      {url: `/api/Leavers/mark-regulatory-reference-not-required`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markRegulatoryReferenceNotRequiredRequest, signal
    },
      );
    }



export const getMarkRegulatoryReferenceNotRequiredMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markRegulatoryReferenceNotRequired>>, TError,{data: MarkRegulatoryReferenceNotRequiredRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markRegulatoryReferenceNotRequired>>, TError,{data: MarkRegulatoryReferenceNotRequiredRequest}, TContext> => {

const mutationKey = ['markRegulatoryReferenceNotRequired'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markRegulatoryReferenceNotRequired>>, {data: MarkRegulatoryReferenceNotRequiredRequest}> = (props) => {
          const {data} = props ?? {};

          return  markRegulatoryReferenceNotRequired(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkRegulatoryReferenceNotRequiredMutationResult = NonNullable<Awaited<ReturnType<typeof markRegulatoryReferenceNotRequired>>>
    export type MarkRegulatoryReferenceNotRequiredMutationBody = MarkRegulatoryReferenceNotRequiredRequest
    export type MarkRegulatoryReferenceNotRequiredMutationError = ProblemDetails

    export const useMarkRegulatoryReferenceNotRequired = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markRegulatoryReferenceNotRequired>>, TError,{data: MarkRegulatoryReferenceNotRequiredRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof markRegulatoryReferenceNotRequired>>,
        TError,
        {data: MarkRegulatoryReferenceNotRequiredRequest},
        TContext
      > => {
      return useMutation(getMarkRegulatoryReferenceNotRequiredMutationOptions(options), queryClient);
    }

export const listRegulatoryReferenceNotRequired = (
    params?: MaybeRef<ListRegulatoryReferenceNotRequiredParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<RegulatoryReferenceNotRequiredRowPagedResponse>(
      {url: `/api/Leavers/regulatory-reference-not-required`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListRegulatoryReferenceNotRequiredQueryKey = (params?: MaybeRef<ListRegulatoryReferenceNotRequiredParams>,) => {
    return [
    'api','Leavers','regulatory-reference-not-required', ...(params ? [params] : [])
    ] as const;
    }


export const getListRegulatoryReferenceNotRequiredQueryOptions = <TData = Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>, TError = ProblemDetails>(params?: MaybeRef<ListRegulatoryReferenceNotRequiredParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRegulatoryReferenceNotRequiredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>> = ({ signal }) => listRegulatoryReferenceNotRequired(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>, TError, TData>
}

export type ListRegulatoryReferenceNotRequiredQueryResult = NonNullable<Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>>
export type ListRegulatoryReferenceNotRequiredQueryError = ProblemDetails



export function useListRegulatoryReferenceNotRequired<TData = Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>, TError = ProblemDetails>(
 params?: MaybeRef<ListRegulatoryReferenceNotRequiredParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReferenceNotRequired>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRegulatoryReferenceNotRequiredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listRegulatoryReferenceCompleted = (
    params?: MaybeRef<ListRegulatoryReferenceCompletedParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<RegulatoryReferenceCompletedRowPagedResponse>(
      {url: `/api/Leavers/regulatory-reference-completed`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListRegulatoryReferenceCompletedQueryKey = (params?: MaybeRef<ListRegulatoryReferenceCompletedParams>,) => {
    return [
    'api','Leavers','regulatory-reference-completed', ...(params ? [params] : [])
    ] as const;
    }


export const getListRegulatoryReferenceCompletedQueryOptions = <TData = Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>, TError = ProblemDetails>(params?: MaybeRef<ListRegulatoryReferenceCompletedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRegulatoryReferenceCompletedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>> = ({ signal }) => listRegulatoryReferenceCompleted(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>, TError, TData>
}

export type ListRegulatoryReferenceCompletedQueryResult = NonNullable<Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>>
export type ListRegulatoryReferenceCompletedQueryError = ProblemDetails



export function useListRegulatoryReferenceCompleted<TData = Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>, TError = ProblemDetails>(
 params?: MaybeRef<ListRegulatoryReferenceCompletedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReferenceCompleted>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRegulatoryReferenceCompletedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getLineManagerReviewEnvelope = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<LineManagerReviewResponse>(
      {url: `/api/processes/${processId}/line-manager-review`, method: 'GET', signal
    },
      );
    }




export const getGetLineManagerReviewEnvelopeQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'line-manager-review'
    ] as const;
    }


export const getGetLineManagerReviewEnvelopeQueryOptions = <TData = Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetLineManagerReviewEnvelopeQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>> = ({ signal }) => getLineManagerReviewEnvelope(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>, TError, TData>
}

export type GetLineManagerReviewEnvelopeQueryResult = NonNullable<Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>>
export type GetLineManagerReviewEnvelopeQueryError = ProblemDetails



export function useGetLineManagerReviewEnvelope<TData = Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLineManagerReviewEnvelope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLineManagerReviewEnvelopeQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeLineManagerReview = (
    processId: MaybeRef<string>,
    completeLineManagerReviewRequest: MaybeRef<CompleteLineManagerReviewRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
completeLineManagerReviewRequest = unref(completeLineManagerReviewRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/line-manager-review/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeLineManagerReviewRequest, signal
    },
      );
    }



export const getCompleteLineManagerReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeLineManagerReview>>, TError,{processId: string;data: CompleteLineManagerReviewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeLineManagerReview>>, TError,{processId: string;data: CompleteLineManagerReviewRequest}, TContext> => {

const mutationKey = ['completeLineManagerReview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeLineManagerReview>>, {processId: string;data: CompleteLineManagerReviewRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  completeLineManagerReview(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteLineManagerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof completeLineManagerReview>>>
    export type CompleteLineManagerReviewMutationBody = CompleteLineManagerReviewRequest
    export type CompleteLineManagerReviewMutationError = ProblemDetails

    export const useCompleteLineManagerReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeLineManagerReview>>, TError,{processId: string;data: CompleteLineManagerReviewRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeLineManagerReview>>,
        TError,
        {processId: string;data: CompleteLineManagerReviewRequest},
        TContext
      > => {
      return useMutation(getCompleteLineManagerReviewMutationOptions(options), queryClient);
    }

export const listMyLineManagerReviews = (

 signal?: AbortSignal
) => {


      return customInstance<LineManagerReviewSummary[]>(
      {url: `/api/me/line-manager-reviews-list`, method: 'GET', signal
    },
      );
    }




export const getListMyLineManagerReviewsQueryKey = () => {
    return [
    'api','me','line-manager-reviews-list'
    ] as const;
    }


export const getListMyLineManagerReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listMyLineManagerReviews>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyLineManagerReviews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMyLineManagerReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyLineManagerReviews>>> = ({ signal }) => listMyLineManagerReviews(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyLineManagerReviews>>, TError, TData>
}

export type ListMyLineManagerReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyLineManagerReviews>>>
export type ListMyLineManagerReviewsQueryError = ProblemDetails



export function useListMyLineManagerReviews<TData = Awaited<ReturnType<typeof listMyLineManagerReviews>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyLineManagerReviews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyLineManagerReviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getCurrentUser = (

 signal?: AbortSignal
) => {


      return customInstance<CurrentUserDto>(
      {url: `/api/me`, method: 'GET', signal
    },
      );
    }




export const getGetCurrentUserQueryKey = () => {
    return [
    'api','me'
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = ProblemDetails



export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getOnboarding = (

 signal?: AbortSignal
) => {


      return customInstance<OnboardingResponse>(
      {url: `/api/onboarding`, method: 'GET', signal
    },
      );
    }




export const getGetOnboardingQueryKey = () => {
    return [
    'api','onboarding'
    ] as const;
    }


export const getGetOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof getOnboarding>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboarding>>> = ({ signal }) => getOnboarding(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>, TError, TData>
}

export type GetOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboarding>>>
export type GetOnboardingQueryError = unknown



export function useGetOnboarding<TData = Awaited<ReturnType<typeof getOnboarding>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeOnboardingStep = (
    stepKey: MaybeRef<string>,
 signal?: AbortSignal
) => {
      stepKey = unref(stepKey);

      return customInstance<void>(
      {url: `/api/onboarding/steps/${stepKey}/complete`, method: 'POST', signal
    },
      );
    }



export const getCompleteOnboardingStepMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboardingStep>>, TError,{stepKey: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeOnboardingStep>>, TError,{stepKey: string}, TContext> => {

const mutationKey = ['completeOnboardingStep'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeOnboardingStep>>, {stepKey: string}> = (props) => {
          const {stepKey} = props ?? {};

          return  completeOnboardingStep(stepKey,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof completeOnboardingStep>>>

    export type CompleteOnboardingStepMutationError = ProblemDetails

    export const useCompleteOnboardingStep = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboardingStep>>, TError,{stepKey: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeOnboardingStep>>,
        TError,
        {stepKey: string},
        TContext
      > => {
      return useMutation(getCompleteOnboardingStepMutationOptions(options), queryClient);
    }

export const dismissOnboarding = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/onboarding/dismiss`, method: 'POST', signal
    },
      );
    }



export const getDismissOnboardingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError,void, TContext> => {

const mutationKey = ['dismissOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissOnboarding>>, void> = () => {


          return  dismissOnboarding()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof dismissOnboarding>>>

    export type DismissOnboardingMutationError = unknown

    export const useDismissOnboarding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof dismissOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDismissOnboardingMutationOptions(options), queryClient);
    }

export const reopenOnboarding = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/onboarding/reopen`, method: 'POST', signal
    },
      );
    }



export const getReopenOnboardingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOnboarding>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reopenOnboarding>>, TError,void, TContext> => {

const mutationKey = ['reopenOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenOnboarding>>, void> = () => {


          return  reopenOnboarding()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof reopenOnboarding>>>

    export type ReopenOnboardingMutationError = unknown

    export const useReopenOnboarding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOnboarding>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reopenOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReopenOnboardingMutationOptions(options), queryClient);
    }

export const getOrganisationalFunctions = (

 signal?: AbortSignal
) => {


      return customInstance<OrganisationalFunctionDto[]>(
      {url: `/api/OrganisationalFunctions`, method: 'GET', signal
    },
      );
    }




export const getGetOrganisationalFunctionsQueryKey = () => {
    return [
    'api','OrganisationalFunctions'
    ] as const;
    }


export const getGetOrganisationalFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationalFunctionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationalFunctions>>> = ({ signal }) => getOrganisationalFunctions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError, TData>
}

export type GetOrganisationalFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisationalFunctions>>>
export type GetOrganisationalFunctionsQueryError = unknown



export function useGetOrganisationalFunctions<TData = Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationalFunctionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const addOrganisationalFunction = (
    createOrganisationalFunctionRequest: MaybeRef<CreateOrganisationalFunctionRequest>,
 signal?: AbortSignal
) => {
      createOrganisationalFunctionRequest = unref(createOrganisationalFunctionRequest);

      return customInstance<OrganisationalFunctionDto>(
      {url: `/api/OrganisationalFunctions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganisationalFunctionRequest, signal
    },
      );
    }



export const getAddOrganisationalFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrganisationalFunction>>, TError,{data: CreateOrganisationalFunctionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addOrganisationalFunction>>, TError,{data: CreateOrganisationalFunctionRequest}, TContext> => {

const mutationKey = ['addOrganisationalFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrganisationalFunction>>, {data: CreateOrganisationalFunctionRequest}> = (props) => {
          const {data} = props ?? {};

          return  addOrganisationalFunction(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOrganisationalFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof addOrganisationalFunction>>>
    export type AddOrganisationalFunctionMutationBody = CreateOrganisationalFunctionRequest
    export type AddOrganisationalFunctionMutationError = ProblemDetails

    export const useAddOrganisationalFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrganisationalFunction>>, TError,{data: CreateOrganisationalFunctionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addOrganisationalFunction>>,
        TError,
        {data: CreateOrganisationalFunctionRequest},
        TContext
      > => {
      return useMutation(getAddOrganisationalFunctionMutationOptions(options), queryClient);
    }

export const removeOrganisationalFunction = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/OrganisationalFunctions/${id}`, method: 'DELETE', signal
    },
      );
    }



export const getRemoveOrganisationalFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrganisationalFunction>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeOrganisationalFunction>>, TError,{id: string}, TContext> => {

const mutationKey = ['removeOrganisationalFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrganisationalFunction>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  removeOrganisationalFunction(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrganisationalFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrganisationalFunction>>>

    export type RemoveOrganisationalFunctionMutationError = ProblemDetails

    export const useRemoveOrganisationalFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrganisationalFunction>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeOrganisationalFunction>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRemoveOrganisationalFunctionMutationOptions(options), queryClient);
    }

export const getOrganisations = (
    params?: MaybeRef<GetOrganisationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<OrganisationResponse[]>(
      {url: `/api/admin/Organisations`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetOrganisationsQueryKey = (params?: MaybeRef<GetOrganisationsParams>,) => {
    return [
    'api','admin','Organisations', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganisationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisations>>, TError = unknown>(params?: MaybeRef<GetOrganisationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisations>>> = ({ signal }) => getOrganisations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>
}

export type GetOrganisationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisations>>>
export type GetOrganisationsQueryError = unknown



export function useGetOrganisations<TData = Awaited<ReturnType<typeof getOrganisations>>, TError = unknown>(
 params?: MaybeRef<GetOrganisationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createOrganisation = (
    createOrganisationRequest: MaybeRef<CreateOrganisationRequest>,
 signal?: AbortSignal
) => {
      createOrganisationRequest = unref(createOrganisationRequest);

      return customInstance<OrganisationResponse>(
      {url: `/api/admin/Organisations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganisationRequest, signal
    },
      );
    }



export const getCreateOrganisationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganisation>>, TError,{data: CreateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOrganisation>>, TError,{data: CreateOrganisationRequest}, TContext> => {

const mutationKey = ['createOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganisation>>, {data: CreateOrganisationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOrganisation(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganisation>>>
    export type CreateOrganisationMutationBody = CreateOrganisationRequest
    export type CreateOrganisationMutationError = ProblemDetails

    export const useCreateOrganisation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganisation>>, TError,{data: CreateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createOrganisation>>,
        TError,
        {data: CreateOrganisationRequest},
        TContext
      > => {
      return useMutation(getCreateOrganisationMutationOptions(options), queryClient);
    }

export const getOrganisationById = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<OrganisationResponse>(
      {url: `/api/admin/Organisations/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetOrganisationByIdQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','admin','Organisations',id
    ] as const;
    }


export const getGetOrganisationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisationById>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationById>>> = ({ signal }) => getOrganisationById(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisationById>>, TError, TData>
}

export type GetOrganisationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisationById>>>
export type GetOrganisationByIdQueryError = ProblemDetails



export function useGetOrganisationById<TData = Awaited<ReturnType<typeof getOrganisationById>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const updateOrganisation = (
    id: MaybeRef<string>,
    updateOrganisationRequest: MaybeRef<UpdateOrganisationRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
updateOrganisationRequest = unref(updateOrganisationRequest);

      return customInstance<OrganisationResponse>(
      {url: `/api/admin/Organisations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganisationRequest, signal
    },
      );
    }



export const getUpdateOrganisationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganisation>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganisation>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext> => {

const mutationKey = ['updateOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganisation>>, {id: string;data: UpdateOrganisationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganisation(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganisation>>>
    export type UpdateOrganisationMutationBody = UpdateOrganisationRequest
    export type UpdateOrganisationMutationError = ProblemDetails

    export const useUpdateOrganisation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganisation>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOrganisation>>,
        TError,
        {id: string;data: UpdateOrganisationRequest},
        TContext
      > => {
      return useMutation(getUpdateOrganisationMutationOptions(options), queryClient);
    }

export const deleteOrganisation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/Organisations/${id}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteOrganisationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganisation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganisation>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganisation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOrganisation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganisation>>>

    export type DeleteOrganisationMutationError = ProblemDetails

    export const useDeleteOrganisation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganisation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteOrganisation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteOrganisationMutationOptions(options), queryClient);
    }

export const getOrganisationPeople = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<PersonResponse[]>(
      {url: `/api/admin/Organisations/${id}/people`, method: 'GET', signal
    },
      );
    }




export const getGetOrganisationPeopleQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','admin','Organisations',id,'people'
    ] as const;
    }


export const getGetOrganisationPeopleQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisationPeople>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationPeople>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationPeopleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationPeople>>> = ({ signal }) => getOrganisationPeople(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisationPeople>>, TError, TData>
}

export type GetOrganisationPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisationPeople>>>
export type GetOrganisationPeopleQueryError = ProblemDetails



export function useGetOrganisationPeople<TData = Awaited<ReturnType<typeof getOrganisationPeople>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationPeople>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationPeopleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listPeople = (
    params?: MaybeRef<ListPeopleParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<PersonResponsePagedResponse>(
      {url: `/api/People`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListPeopleQueryKey = (params?: MaybeRef<ListPeopleParams>,) => {
    return [
    'api','People', ...(params ? [params] : [])
    ] as const;
    }


export const getListPeopleQueryOptions = <TData = Awaited<ReturnType<typeof listPeople>>, TError = ProblemDetails>(params?: MaybeRef<ListPeopleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPeopleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPeople>>> = ({ signal }) => listPeople(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>
}

export type ListPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof listPeople>>>
export type ListPeopleQueryError = ProblemDetails



export function useListPeople<TData = Awaited<ReturnType<typeof listPeople>>, TError = ProblemDetails>(
 params?: MaybeRef<ListPeopleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPeopleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createPerson = (
    createPersonRequest: MaybeRef<CreatePersonRequest>,
 signal?: AbortSignal
) => {
      createPersonRequest = unref(createPersonRequest);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPersonRequest, signal
    },
      );
    }



export const getCreatePersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: CreatePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: CreatePersonRequest}, TContext> => {

const mutationKey = ['createPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson>>, {data: CreatePersonRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPerson(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof createPerson>>>
    export type CreatePersonMutationBody = CreatePersonRequest
    export type CreatePersonMutationError = ProblemDetails

    export const useCreatePerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: CreatePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPerson>>,
        TError,
        {data: CreatePersonRequest},
        TContext
      > => {
      return useMutation(getCreatePersonMutationOptions(options), queryClient);
    }

export const listLineManagerCandidates = (
    params?: MaybeRef<ListLineManagerCandidatesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<LineManagerCandidateResponse[]>(
      {url: `/api/People/line-manager-candidates`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListLineManagerCandidatesQueryKey = (params?: MaybeRef<ListLineManagerCandidatesParams>,) => {
    return [
    'api','People','line-manager-candidates', ...(params ? [params] : [])
    ] as const;
    }


export const getListLineManagerCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listLineManagerCandidates>>, TError = unknown>(params?: MaybeRef<ListLineManagerCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineManagerCandidates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListLineManagerCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLineManagerCandidates>>> = ({ signal }) => listLineManagerCandidates(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLineManagerCandidates>>, TError, TData>
}

export type ListLineManagerCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listLineManagerCandidates>>>
export type ListLineManagerCandidatesQueryError = unknown



export function useListLineManagerCandidates<TData = Awaited<ReturnType<typeof listLineManagerCandidates>>, TError = unknown>(
 params?: MaybeRef<ListLineManagerCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineManagerCandidates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLineManagerCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listPeopleJobTitles = (

 signal?: AbortSignal
) => {


      return customInstance<string[]>(
      {url: `/api/People/job-titles`, method: 'GET', signal
    },
      );
    }




export const getListPeopleJobTitlesQueryKey = () => {
    return [
    'api','People','job-titles'
    ] as const;
    }


export const getListPeopleJobTitlesQueryOptions = <TData = Awaited<ReturnType<typeof listPeopleJobTitles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeopleJobTitles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPeopleJobTitlesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPeopleJobTitles>>> = ({ signal }) => listPeopleJobTitles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPeopleJobTitles>>, TError, TData>
}

export type ListPeopleJobTitlesQueryResult = NonNullable<Awaited<ReturnType<typeof listPeopleJobTitles>>>
export type ListPeopleJobTitlesQueryError = unknown



export function useListPeopleJobTitles<TData = Awaited<ReturnType<typeof listPeopleJobTitles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeopleJobTitles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPeopleJobTitlesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getPerson = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPersonQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','People',id
    ] as const;
    }


export const getGetPersonQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPersonQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>
}

export type GetPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonQueryError = ProblemDetails



export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const editPerson = (
    id: MaybeRef<string>,
    editPersonRequest: MaybeRef<EditPersonRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
editPersonRequest = unref(editPersonRequest);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: editPersonRequest, signal
    },
      );
    }



export const getEditPersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPerson>>, TError,{id: string;data: EditPersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof editPerson>>, TError,{id: string;data: EditPersonRequest}, TContext> => {

const mutationKey = ['editPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPerson>>, {id: string;data: EditPersonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  editPerson(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPersonMutationResult = NonNullable<Awaited<ReturnType<typeof editPerson>>>
    export type EditPersonMutationBody = EditPersonRequest
    export type EditPersonMutationError = ProblemDetails

    export const useEditPerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPerson>>, TError,{id: string;data: EditPersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof editPerson>>,
        TError,
        {id: string;data: EditPersonRequest},
        TContext
      > => {
      return useMutation(getEditPersonMutationOptions(options), queryClient);
    }

export const reInvitePerson = (
    id: MaybeRef<string>,
    reInvitePersonRequest: MaybeRef<ReInvitePersonRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
reInvitePersonRequest = unref(reInvitePersonRequest);

      return customInstance<void>(
      {url: `/api/People/${id}/re-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reInvitePersonRequest, signal
    },
      );
    }



export const getReInvitePersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reInvitePerson>>, TError,{id: string;data: ReInvitePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reInvitePerson>>, TError,{id: string;data: ReInvitePersonRequest}, TContext> => {

const mutationKey = ['reInvitePerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reInvitePerson>>, {id: string;data: ReInvitePersonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  reInvitePerson(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReInvitePersonMutationResult = NonNullable<Awaited<ReturnType<typeof reInvitePerson>>>
    export type ReInvitePersonMutationBody = ReInvitePersonRequest
    export type ReInvitePersonMutationError = ProblemDetails

    export const useReInvitePerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reInvitePerson>>, TError,{id: string;data: ReInvitePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reInvitePerson>>,
        TError,
        {id: string;data: ReInvitePersonRequest},
        TContext
      > => {
      return useMutation(getReInvitePersonMutationOptions(options), queryClient);
    }

export const invitePerson = (
    invitePersonRequest: MaybeRef<InvitePersonRequest>,
 signal?: AbortSignal
) => {
      invitePersonRequest = unref(invitePersonRequest);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitePersonRequest, signal
    },
      );
    }



export const getInvitePersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitePerson>>, TError,{data: InvitePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invitePerson>>, TError,{data: InvitePersonRequest}, TContext> => {

const mutationKey = ['invitePerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitePerson>>, {data: InvitePersonRequest}> = (props) => {
          const {data} = props ?? {};

          return  invitePerson(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvitePersonMutationResult = NonNullable<Awaited<ReturnType<typeof invitePerson>>>
    export type InvitePersonMutationBody = InvitePersonRequest
    export type InvitePersonMutationError = ProblemDetails

    export const useInvitePerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitePerson>>, TError,{data: InvitePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof invitePerson>>,
        TError,
        {data: InvitePersonRequest},
        TContext
      > => {
      return useMutation(getInvitePersonMutationOptions(options), queryClient);
    }

export const cancelEmailChange = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/People/${id}/email-change`, method: 'DELETE', signal
    },
      );
    }



export const getCancelEmailChangeMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmailChange>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelEmailChange>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelEmailChange'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEmailChange>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelEmailChange(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEmailChange>>>

    export type CancelEmailChangeMutationError = ProblemDetails

    export const useCancelEmailChange = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmailChange>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelEmailChange>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelEmailChangeMutationOptions(options), queryClient);
    }

export const acceptPersonInvitation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/People/${id}/accept-invitation`, method: 'POST', signal
    },
      );
    }



export const getAcceptPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPersonInvitation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptPersonInvitation>>, TError,{id: string}, TContext> => {

const mutationKey = ['acceptPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptPersonInvitation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptPersonInvitation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptPersonInvitation>>>

    export type AcceptPersonInvitationMutationError = ProblemDetails

    export const useAcceptPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPersonInvitation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptPersonInvitation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAcceptPersonInvitationMutationOptions(options), queryClient);
    }

export const cancelPersonInvitation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/People/${id}/cancel-invitation`, method: 'POST', signal
    },
      );
    }



export const getCancelPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPersonInvitation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelPersonInvitation>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPersonInvitation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelPersonInvitation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPersonInvitation>>>

    export type CancelPersonInvitationMutationError = ProblemDetails

    export const useCancelPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPersonInvitation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelPersonInvitation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelPersonInvitationMutationOptions(options), queryClient);
    }

export const checkPersonEmailAvailability = (
    params?: MaybeRef<CheckPersonEmailAvailabilityParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<EmailAvailabilityResponse>(
      {url: `/api/People/check-email-availability`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getCheckPersonEmailAvailabilityQueryKey = (params?: MaybeRef<CheckPersonEmailAvailabilityParams>,) => {
    return [
    'api','People','check-email-availability', ...(params ? [params] : [])
    ] as const;
    }


export const getCheckPersonEmailAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError = ProblemDetails>(params?: MaybeRef<CheckPersonEmailAvailabilityParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCheckPersonEmailAvailabilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkPersonEmailAvailability>>> = ({ signal }) => checkPersonEmailAvailability(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError, TData>
}

export type CheckPersonEmailAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof checkPersonEmailAvailability>>>
export type CheckPersonEmailAvailabilityQueryError = ProblemDetails



export function useCheckPersonEmailAvailability<TData = Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError = ProblemDetails>(
 params?: MaybeRef<CheckPersonEmailAvailabilityParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckPersonEmailAvailabilityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const markNotRequired = (
    markNotRequiredRequest: MaybeRef<MarkNotRequiredRequest>,
 signal?: AbortSignal
) => {
      markNotRequiredRequest = unref(markNotRequiredRequest);

      return customInstance<void>(
      {url: `/api/People/mark-not-required`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markNotRequiredRequest, signal
    },
      );
    }



export const getMarkNotRequiredMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotRequired>>, TError,{data: MarkNotRequiredRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markNotRequired>>, TError,{data: MarkNotRequiredRequest}, TContext> => {

const mutationKey = ['markNotRequired'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotRequired>>, {data: MarkNotRequiredRequest}> = (props) => {
          const {data} = props ?? {};

          return  markNotRequired(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotRequiredMutationResult = NonNullable<Awaited<ReturnType<typeof markNotRequired>>>
    export type MarkNotRequiredMutationBody = MarkNotRequiredRequest
    export type MarkNotRequiredMutationError = ProblemDetails

    export const useMarkNotRequired = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotRequired>>, TError,{data: MarkNotRequiredRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof markNotRequired>>,
        TError,
        {data: MarkNotRequiredRequest},
        TContext
      > => {
      return useMutation(getMarkNotRequiredMutationOptions(options), queryClient);
    }

export const initiatePeople = (
    initiateRequest: MaybeRef<InitiateRequest>,
 signal?: AbortSignal
) => {
      initiateRequest = unref(initiateRequest);

      return customInstance<void>(
      {url: `/api/People/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateRequest, signal
    },
      );
    }



export const getInitiatePeopleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePeople>>, TError,{data: InitiateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof initiatePeople>>, TError,{data: InitiateRequest}, TContext> => {

const mutationKey = ['initiatePeople'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatePeople>>, {data: InitiateRequest}> = (props) => {
          const {data} = props ?? {};

          return  initiatePeople(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiatePeopleMutationResult = NonNullable<Awaited<ReturnType<typeof initiatePeople>>>
    export type InitiatePeopleMutationBody = InitiateRequest
    export type InitiatePeopleMutationError = ProblemDetails

    export const useInitiatePeople = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePeople>>, TError,{data: InitiateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof initiatePeople>>,
        TError,
        {data: InitiateRequest},
        TContext
      > => {
      return useMutation(getInitiatePeopleMutationOptions(options), queryClient);
    }

export const listPersonDocuments = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<PersonDocumentSummary[]>(
      {url: `/api/People/${id}/documents`, method: 'GET', signal
    },
      );
    }




export const getListPersonDocumentsQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','People',id,'documents'
    ] as const;
    }


export const getListPersonDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listPersonDocuments>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPersonDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonDocuments>>> = ({ signal }) => listPersonDocuments(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonDocuments>>, TError, TData>
}

export type ListPersonDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonDocuments>>>
export type ListPersonDocumentsQueryError = ProblemDetails



export function useListPersonDocuments<TData = Awaited<ReturnType<typeof listPersonDocuments>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPersonDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPersonDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createPersonDocumentDownloadUrl = (
    id: MaybeRef<string>,
    documentId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
documentId = unref(documentId);

      return customInstance<DocumentDownloadUrlResponse>(
      {url: `/api/People/${id}/documents/${documentId}/download-url`, method: 'POST', signal
    },
      );
    }



export const getCreatePersonDocumentDownloadUrlMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPersonDocumentDownloadUrl>>, TError,{id: string;documentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPersonDocumentDownloadUrl>>, TError,{id: string;documentId: string}, TContext> => {

const mutationKey = ['createPersonDocumentDownloadUrl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPersonDocumentDownloadUrl>>, {id: string;documentId: string}> = (props) => {
          const {id,documentId} = props ?? {};

          return  createPersonDocumentDownloadUrl(id,documentId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonDocumentDownloadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof createPersonDocumentDownloadUrl>>>

    export type CreatePersonDocumentDownloadUrlMutationError = ProblemDetails

    export const useCreatePersonDocumentDownloadUrl = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPersonDocumentDownloadUrl>>, TError,{id: string;documentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPersonDocumentDownloadUrl>>,
        TError,
        {id: string;documentId: string},
        TContext
      > => {
      return useMutation(getCreatePersonDocumentDownloadUrlMutationOptions(options), queryClient);
    }

export const devEmailTest = (
    emailTestRequest: MaybeRef<EmailTestRequest>,
 signal?: AbortSignal
) => {
      emailTestRequest = unref(emailTestRequest);

      return customInstance<void>(
      {url: `/dev/email-test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailTestRequest, signal
    },
      );
    }



export const getDevEmailTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTest>>, TError,{data: EmailTestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof devEmailTest>>, TError,{data: EmailTestRequest}, TContext> => {

const mutationKey = ['devEmailTest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devEmailTest>>, {data: EmailTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  devEmailTest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevEmailTestMutationResult = NonNullable<Awaited<ReturnType<typeof devEmailTest>>>
    export type DevEmailTestMutationBody = EmailTestRequest
    export type DevEmailTestMutationError = unknown

    export const useDevEmailTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTest>>, TError,{data: EmailTestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof devEmailTest>>,
        TError,
        {data: EmailTestRequest},
        TContext
      > => {
      return useMutation(getDevEmailTestMutationOptions(options), queryClient);
    }

export const devEmailTemplateTest = (
    emailTemplateTestRequest: MaybeRef<EmailTemplateTestRequest>,
 signal?: AbortSignal
) => {
      emailTemplateTestRequest = unref(emailTemplateTestRequest);

      return customInstance<void>(
      {url: `/dev/email-template-test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailTemplateTestRequest, signal
    },
      );
    }



export const getDevEmailTemplateTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTemplateTest>>, TError,{data: EmailTemplateTestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof devEmailTemplateTest>>, TError,{data: EmailTemplateTestRequest}, TContext> => {

const mutationKey = ['devEmailTemplateTest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devEmailTemplateTest>>, {data: EmailTemplateTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  devEmailTemplateTest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevEmailTemplateTestMutationResult = NonNullable<Awaited<ReturnType<typeof devEmailTemplateTest>>>
    export type DevEmailTemplateTestMutationBody = EmailTemplateTestRequest
    export type DevEmailTemplateTestMutationError = unknown

    export const useDevEmailTemplateTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTemplateTest>>, TError,{data: EmailTemplateTestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof devEmailTemplateTest>>,
        TError,
        {data: EmailTemplateTestRequest},
        TContext
      > => {
      return useMutation(getDevEmailTemplateTestMutationOptions(options), queryClient);
    }

export const listRegulatoryFunctions = (
    params?: MaybeRef<ListRegulatoryFunctionsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<RegulatoryFunctionResponse[]>(
      {url: `/api/admin/regulatory-functions`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListRegulatoryFunctionsQueryKey = (params?: MaybeRef<ListRegulatoryFunctionsParams>,) => {
    return [
    'api','admin','regulatory-functions', ...(params ? [params] : [])
    ] as const;
    }


export const getListRegulatoryFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError = unknown>(params?: MaybeRef<ListRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRegulatoryFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegulatoryFunctions>>> = ({ signal }) => listRegulatoryFunctions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError, TData>
}

export type ListRegulatoryFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegulatoryFunctions>>>
export type ListRegulatoryFunctionsQueryError = unknown



export function useListRegulatoryFunctions<TData = Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError = unknown>(
 params?: MaybeRef<ListRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRegulatoryFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createRegulatoryFunction = (
    createRegulatoryFunctionRequest: MaybeRef<CreateRegulatoryFunctionRequest>,
 signal?: AbortSignal
) => {
      createRegulatoryFunctionRequest = unref(createRegulatoryFunctionRequest);

      return customInstance<RegulatoryFunctionResponse>(
      {url: `/api/admin/regulatory-functions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRegulatoryFunctionRequest, signal
    },
      );
    }



export const getCreateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegulatoryFunction>>, TError,{data: CreateRegulatoryFunctionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createRegulatoryFunction>>, TError,{data: CreateRegulatoryFunctionRequest}, TContext> => {

const mutationKey = ['createRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRegulatoryFunction>>, {data: CreateRegulatoryFunctionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createRegulatoryFunction(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof createRegulatoryFunction>>>
    export type CreateRegulatoryFunctionMutationBody = CreateRegulatoryFunctionRequest
    export type CreateRegulatoryFunctionMutationError = ProblemDetails

    export const useCreateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegulatoryFunction>>, TError,{data: CreateRegulatoryFunctionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createRegulatoryFunction>>,
        TError,
        {data: CreateRegulatoryFunctionRequest},
        TContext
      > => {
      return useMutation(getCreateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const updateRegulatoryFunction = (
    id: MaybeRef<string>,
    updateRegulatoryFunctionRequest: MaybeRef<UpdateRegulatoryFunctionRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
updateRegulatoryFunctionRequest = unref(updateRegulatoryFunctionRequest);

      return customInstance<RegulatoryFunctionResponse>(
      {url: `/api/admin/regulatory-functions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRegulatoryFunctionRequest, signal
    },
      );
    }



export const getUpdateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegulatoryFunction>>, TError,{id: string;data: UpdateRegulatoryFunctionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateRegulatoryFunction>>, TError,{id: string;data: UpdateRegulatoryFunctionRequest}, TContext> => {

const mutationKey = ['updateRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRegulatoryFunction>>, {id: string;data: UpdateRegulatoryFunctionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRegulatoryFunction(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof updateRegulatoryFunction>>>
    export type UpdateRegulatoryFunctionMutationBody = UpdateRegulatoryFunctionRequest
    export type UpdateRegulatoryFunctionMutationError = ProblemDetails

    export const useUpdateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegulatoryFunction>>, TError,{id: string;data: UpdateRegulatoryFunctionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRegulatoryFunction>>,
        TError,
        {id: string;data: UpdateRegulatoryFunctionRequest},
        TContext
      > => {
      return useMutation(getUpdateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const activateRegulatoryFunction = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/regulatory-functions/${id}/activate`, method: 'PATCH', signal
    },
      );
    }



export const getActivateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateRegulatoryFunction>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateRegulatoryFunction>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateRegulatoryFunction>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateRegulatoryFunction(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof activateRegulatoryFunction>>>

    export type ActivateRegulatoryFunctionMutationError = ProblemDetails

    export const useActivateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateRegulatoryFunction>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateRegulatoryFunction>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getActivateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const deactivateRegulatoryFunction = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/regulatory-functions/${id}/deactivate`, method: 'PATCH', signal
    },
      );
    }



export const getDeactivateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateRegulatoryFunction(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>>

    export type DeactivateRegulatoryFunctionMutationError = ProblemDetails

    export const useDeactivateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivateRegulatoryFunction>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeactivateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const getRegulatoryFunctions = (
    params?: MaybeRef<GetRegulatoryFunctionsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<RegulatoryFunctionDto[]>(
      {url: `/api/RegulatoryFunctions`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetRegulatoryFunctionsQueryKey = (params?: MaybeRef<GetRegulatoryFunctionsParams>,) => {
    return [
    'api','RegulatoryFunctions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetRegulatoryFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError = unknown>(params?: MaybeRef<GetRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetRegulatoryFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulatoryFunctions>>> = ({ signal }) => getRegulatoryFunctions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError, TData>
}

export type GetRegulatoryFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulatoryFunctions>>>
export type GetRegulatoryFunctionsQueryError = unknown



export function useGetRegulatoryFunctions<TData = Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError = unknown>(
 params?: MaybeRef<GetRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulatoryFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getSelfDeclaration = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<SelfDeclarationResponse>(
      {url: `/api/processes/${processId}/self-declaration`, method: 'GET', signal
    },
      );
    }




export const getGetSelfDeclarationQueryKey = (processId: MaybeRef<string>,) => {
    return [
    'api','processes',processId,'self-declaration'
    ] as const;
    }


export const getGetSelfDeclarationQueryOptions = <TData = Awaited<ReturnType<typeof getSelfDeclaration>>, TError = ProblemDetails>(processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelfDeclaration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSelfDeclarationQueryKey(processId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelfDeclaration>>> = ({ signal }) => getSelfDeclaration(processId, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(processId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSelfDeclaration>>, TError, TData>
}

export type GetSelfDeclarationQueryResult = NonNullable<Awaited<ReturnType<typeof getSelfDeclaration>>>
export type GetSelfDeclarationQueryError = ProblemDetails



export function useGetSelfDeclaration<TData = Awaited<ReturnType<typeof getSelfDeclaration>>, TError = ProblemDetails>(
 processId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelfDeclaration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSelfDeclarationQueryOptions(processId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const saveSelfDeclarationDraft = (
    processId: MaybeRef<string>,
    selfDeclarationForm: MaybeRef<SelfDeclarationForm>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
selfDeclarationForm = unref(selfDeclarationForm);

      return customInstance<void>(
      {url: `/api/processes/${processId}/self-declaration/draft`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: selfDeclarationForm, signal
    },
      );
    }



export const getSaveSelfDeclarationDraftMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSelfDeclarationDraft>>, TError,{processId: string;data: SelfDeclarationForm}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveSelfDeclarationDraft>>, TError,{processId: string;data: SelfDeclarationForm}, TContext> => {

const mutationKey = ['saveSelfDeclarationDraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSelfDeclarationDraft>>, {processId: string;data: SelfDeclarationForm}> = (props) => {
          const {processId,data} = props ?? {};

          return  saveSelfDeclarationDraft(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveSelfDeclarationDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveSelfDeclarationDraft>>>
    export type SaveSelfDeclarationDraftMutationBody = SelfDeclarationForm
    export type SaveSelfDeclarationDraftMutationError = ProblemDetails

    export const useSaveSelfDeclarationDraft = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSelfDeclarationDraft>>, TError,{processId: string;data: SelfDeclarationForm}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof saveSelfDeclarationDraft>>,
        TError,
        {processId: string;data: SelfDeclarationForm},
        TContext
      > => {
      return useMutation(getSaveSelfDeclarationDraftMutationOptions(options), queryClient);
    }

export const submitSelfDeclaration = (
    processId: MaybeRef<string>,
    submitSelfDeclarationRequest: MaybeRef<SubmitSelfDeclarationRequest>,
 signal?: AbortSignal
) => {
      processId = unref(processId);
submitSelfDeclarationRequest = unref(submitSelfDeclarationRequest);

      return customInstance<void>(
      {url: `/api/processes/${processId}/self-declaration/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitSelfDeclarationRequest, signal
    },
      );
    }



export const getSubmitSelfDeclarationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSelfDeclaration>>, TError,{processId: string;data: SubmitSelfDeclarationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitSelfDeclaration>>, TError,{processId: string;data: SubmitSelfDeclarationRequest}, TContext> => {

const mutationKey = ['submitSelfDeclaration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitSelfDeclaration>>, {processId: string;data: SubmitSelfDeclarationRequest}> = (props) => {
          const {processId,data} = props ?? {};

          return  submitSelfDeclaration(processId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitSelfDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof submitSelfDeclaration>>>
    export type SubmitSelfDeclarationMutationBody = SubmitSelfDeclarationRequest
    export type SubmitSelfDeclarationMutationError = ProblemDetails

    export const useSubmitSelfDeclaration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSelfDeclaration>>, TError,{processId: string;data: SubmitSelfDeclarationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof submitSelfDeclaration>>,
        TError,
        {processId: string;data: SubmitSelfDeclarationRequest},
        TContext
      > => {
      return useMutation(getSubmitSelfDeclarationMutationOptions(options), queryClient);
    }

export const reopenSelfDeclaration = (
    processId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      processId = unref(processId);

      return customInstance<void>(
      {url: `/api/processes/${processId}/self-declaration/reopen`, method: 'POST', signal
    },
      );
    }



export const getReopenSelfDeclarationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenSelfDeclaration>>, TError,{processId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reopenSelfDeclaration>>, TError,{processId: string}, TContext> => {

const mutationKey = ['reopenSelfDeclaration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenSelfDeclaration>>, {processId: string}> = (props) => {
          const {processId} = props ?? {};

          return  reopenSelfDeclaration(processId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenSelfDeclarationMutationResult = NonNullable<Awaited<ReturnType<typeof reopenSelfDeclaration>>>

    export type ReopenSelfDeclarationMutationError = ProblemDetails

    export const useReopenSelfDeclaration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenSelfDeclaration>>, TError,{processId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reopenSelfDeclaration>>,
        TError,
        {processId: string},
        TContext
      > => {
      return useMutation(getReopenSelfDeclarationMutationOptions(options), queryClient);
    }

export const listMySelfDeclarations = (
    params?: MaybeRef<ListMySelfDeclarationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<MySelfDeclarationSummary[]>(
      {url: `/api/me/self-declarations`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListMySelfDeclarationsQueryKey = (params?: MaybeRef<ListMySelfDeclarationsParams>,) => {
    return [
    'api','me','self-declarations', ...(params ? [params] : [])
    ] as const;
    }


export const getListMySelfDeclarationsQueryOptions = <TData = Awaited<ReturnType<typeof listMySelfDeclarations>>, TError = ProblemDetails>(params?: MaybeRef<ListMySelfDeclarationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySelfDeclarations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMySelfDeclarationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMySelfDeclarations>>> = ({ signal }) => listMySelfDeclarations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMySelfDeclarations>>, TError, TData>
}

export type ListMySelfDeclarationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMySelfDeclarations>>>
export type ListMySelfDeclarationsQueryError = ProblemDetails



export function useListMySelfDeclarations<TData = Awaited<ReturnType<typeof listMySelfDeclarations>>, TError = ProblemDetails>(
 params?: MaybeRef<ListMySelfDeclarationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMySelfDeclarations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMySelfDeclarationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
